export default {
  // Common
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    noData: 'Sin datos',
    confirm: 'Confirmar',
    close: 'Cerrar',
    yes: 'Sí',
    no: 'No',
    actions: 'Acciones',
    status: 'Estado',
    date: 'Fecha',
    name: 'Nombre',
    description: 'Descripción',
    type: 'Tipo',
    download: 'Descargar',
    upload: 'Subir',
    copy: 'Copiar',
    copied: '¡Copiado!',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    all: 'Todo',
    allTypes: 'Todos los tipos',
    allStatuses: 'Todos los estados',
    none: 'Ninguno',
    active: 'Activo',
    inactive: 'Inactivo',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    refresh: 'Actualizar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    finish: 'Finalizar',
    submit: 'Enviar',
    confirmDeleteItem: '¿Desea eliminar este elemento?',
    validateForReport: 'Validar para Informe',
    reset: 'Restablecer',
    view: 'Ver',
    details: 'Detalles',
    more: 'Más',
    less: 'Menos',
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    optional: 'Opcional',
    required: 'Requerido',
    note: 'Nota:',
    and: 'y',
    andThe: 'y los',
    or: 'o',
    sending: 'Enviando...',
    redirecting: 'Redirigiendo...',
    copyright: '© 2026 SYLink. Todos los derechos reservados.',
    add: 'Agregar',
    execute: 'Ejecutar',
    launch: 'Lanzar',
    pause: 'Pausar',
    generating: 'Generando...',
    copiedToClipboard: 'Copiado al portapapeles',
    emailRequired: 'Correo electrónico requerido',
    regenerate: 'Regenerar',
    deselect: 'Deseleccionar',
    unknown: 'Desconocido',
    notDetected: 'No detectado',
    notDetectedFeminine: 'No detectada',
    notAvailable: 'No disponible',
    requiredFields: 'Campos obligatorios',
    useAssistant: 'Utilice el asistente IA para comenzar',
    goBack: 'Volver al panel de control'
  },

  // Navigation
  nav: {
    dashboard: 'Panel de control',
    scans: 'Escaneos',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilidades',
    reports: 'Informes',
    settings: 'Configuración',
    account: 'Mi cuenta',
    logout: 'Cerrar sesión',
    help: 'Ayuda',
    admin: 'Administración',
    tools: 'Herramientas',
    compliance: 'Cumplimiento',
    notifications: 'Notificaciones',
    credentials: 'Credenciales',
    ad: 'Active Directory',
    sessions: 'Sesiones',
    agents: 'Agentes'
  },

  // Auth
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    magicLink: 'Magic Link',
    resetPassword: 'Restablecer contraseña',
    resetPasswordNeedsLink: 'Para restablecer tu contraseña, utiliza el enlace enviado por correo electrónico. Puedes solicitar un nuevo enlace desde la página de inicio de sesión.',
    rememberMe: 'Recordarme',
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Credenciales incorrectas',
    logoutSuccess: 'Cierre de sesión exitoso',
    sessionExpired: 'Sesión expirada',
    twoFactor: 'Autenticación de dos factores',
    enterCode: 'Ingresa el código',
    verifyCode: 'Verificar código',
    invalidCode: 'Código inválido',
    // Register page
    createAccount: 'Crear una cuenta',
    fillFormBelowEmail: 'Complete el formulario a continuación para crear su cuenta empresarial.',
    companyName: 'Nombre de la empresa',
    companyPlaceholder: 'Su empresa',
    firstName: 'Nombre',
    firstNamePlaceholder: 'Su nombre',
    lastName: 'Apellido',
    lastNamePlaceholder: 'Su apellido',
    professionalEmail: 'Email profesional',
    professionalEmailPlaceholder: 'usted@suempresa.com',
    professionalPhone: 'Teléfono profesional',
    phonePlaceholder: '+34 612 345 678',
    passwordEmailNote: 'Definirá su contraseña después de validar su email.',
    acceptTermsPrefix: 'Acepto los',
    createMyAccount: 'Crear mi cuenta',
    registering: 'Creando...',
    alreadyHaveAccount: '¿Ya tiene una cuenta?',
    loginButton: 'Iniciar sesión',
    byRegistering: 'Al crear una cuenta, acepta nuestros términos de uso y política de privacidad.',
    registrationSuccess: '¡Registro exitoso!',
    registrationEmailSent: 'Se ha enviado un email de confirmación a',
    clickLinkToSetPassword: 'Haga clic en el enlace para establecer su contraseña y activar su cuenta.',
    checkSpam: 'Revise su carpeta de spam si no ve el email.',
    backToLogin: 'Volver al inicio de sesión',
    // Email verification
    verifying: 'Verificando...',
    verifyingDescription: 'Por favor espere mientras verificamos su dirección de email.',
    emailVerified: '¡Email verificado!',
    accountActive: 'Su cuenta está ahora activa.',
    welcome: '¡Bienvenido a SYLink!',
    choosePlan: 'Elegir mi plan',
    redirectingToPlan: 'Redirigiendo a precios en {seconds} segundos...',
    orLoginDirectly: 'O {loginLink} directamente',
    verificationFailed: 'Verificación fallida',
    needNewVerificationLink: '¿Necesita un nuevo enlace de verificación?',
    yourEmail: 'Su email',
    emailSent: '¡Email enviado!',
    resendLink: 'Reenviar enlace',
    invalidLink: 'Enlace inválido',
    requestNewVerificationLink: 'Solicitar un nuevo enlace de verificación',
    sendLink: 'Enviar enlace',
    // Login page
    welcomeBack: '¡Bienvenido de nuevo!',
    enterCredentials: 'Ingrese sus credenciales para acceder a su espacio.',
    loggingIn: 'Iniciando sesión...',
    noAccount: '¿No tiene cuenta?',
    createAccountLink: 'Crear una cuenta',
    createFreeAccount: 'Crear una cuenta gratuita',
    // Password reset
    resetPasswordTitle: 'Restablecer contraseña',
    resetPasswordDesc: 'Ingrese su email para recibir un enlace de restablecimiento.',
    sendResetLink: 'Enviar enlace',
    sending: 'Enviando...',
    resetLinkSent: '¡Enlace enviado!',
    resetLinkSentDesc: 'Revise su correo para restablecer su contraseña.',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar contraseña',
    setNewPassword: 'Establecer contraseña',
    passwordUpdated: '¡Contraseña actualizada!',
    passwordUpdatedDesc: 'Ahora puede iniciar sesión con su nueva contraseña.',
    // Additional auth keys
    accountBlocked: 'Cuenta bloqueada',
    autoRedirecting: 'Redirección automática...',
    charactersCount: '{count} caracteres',
    checkYourInbox: 'Revise su bandeja de entrada',
    chooseSecurePassword: 'Elija una contraseña segura para su cuenta',
    classic: 'Clásica',
    confirmPasswordPlaceholder: 'Confirme su contraseña',
    connectionError: 'Error de conexión. Verifique su conexión a internet e inténtelo de nuevo.',
    createAccountWithProfessionalEmail: 'Crear una cuenta con email profesional',
    createDemoAccount: 'Crear su cuenta demo',
    createNewAccountMessage: 'Para continuar, cree una nueva cuenta con su email profesional:',
    demoAccountReady: '¡Su cuenta demo está lista!',
    emailAddressLabel: 'Dirección de email',
    emailNotVerified: 'Email no verificado',
    emailNotVerifiedMessage: 'Por favor revise su bandeja de entrada y haga clic en el enlace de confirmación.',
    emailOrUsername: 'Dirección de email',
    emailPlaceholder: 'su-email@ejemplo.com',
    emailSentTitle: 'Email enviado',
    enterEmailForResetLink: 'Ingrese su dirección de email y le enviaremos un enlace para restablecer su contraseña.',
    fillDemoInfo: 'Complete su información para acceder a su espacio demo.',
    forgotPasswordModalTitle: '¿Olvidó su contraseña?',
    genericError: 'Ha ocurrido un error. Por favor inténtelo de nuevo.',
    ifAccountExistsPrefix: 'Si existe una cuenta con la dirección',
    ifAccountExistsSuffix: ', recibirá un enlace para restablecer su contraseña.',
    linkExpiresCheckSpam: 'El enlace expirará en 24 horas. Recuerde revisar su carpeta de spam.',
    loginSubtitle: 'Inicie sesión para acceder a su espacio de seguridad.',
    lowercase: '1 minúscula',
    magicLinkExpired: 'Este enlace ha expirado. Por favor solicite uno nuevo.',
    magicLinkFooter: 'Magic Link - Inicio de sesión seguro sin contraseña',
    magicLinkInvalid: 'Este enlace ya no es válido.',
    magicLinkLoginFailed: 'El inicio de sesión falló. Por favor inténtelo de nuevo.',
    magicLinkNotFound: 'Este enlace no existe o ya fue utilizado.',
    minChars: 'Mín. 8 caracteres',
    needHelp: '¿Necesita ayuda? Contáctenos',
    newPasswordPlaceholder: 'Ingrese su nueva contraseña',
    number: '1 número',
    orEnterManually: 'o ingrese manualmente',
    passwordChanged: '¡Contraseña cambiada!',
    passwordGenerator: 'Generador de contraseñas',
    passwordMinLength: 'Mínimo 8 caracteres',
    passwordMinLengthError: 'La contraseña debe contener al menos 8 caracteres',
    passwordPlaceholder: 'Contraseña',
    passwordResetSuccess: 'Su contraseña ha sido restablecida con éxito. Será redirigido a la página de inicio de sesión.',
    passwordsMatch: 'Contraseñas idénticas',
    personalEmailBlockedMessage: 'Esta cuenta utiliza una dirección de email personal que ya no es aceptada.',
    personalEmailsNotAccepted: 'Los emails personales (Gmail, Hotmail, Yahoo, etc.) no son aceptados.',
    phoneFormatHint: 'El prefijo se completa automáticamente. Formato: +34 612 345 678',
    professionalEmailOnly: 'Solo se permiten direcciones de email profesionales.',
    quantumResistant: 'Resistente a Quantum',
    quantumSecurityDescription: 'Máxima seguridad contra futuros ataques cuánticos',
    redirectingToDashboard: 'Será redirigido a su panel de control...',
    regenerate: 'Regenerar',
    requestNewMagicLink: 'Puede solicitar un nuevo magic link desde la página de inicio de sesión.',
    resendVerificationLink: 'Reenviar el email de verificación',
    resettingPassword: 'Restableciendo...',
    retrying: 'Nuevo intento...',
    securityPolicy: 'Política de seguridad:',
    sendResetLinkFull: 'Enviar enlace de restablecimiento',
    sendingInProgress: 'Enviando...',
    specialChar: '1 carácter especial',
    unauthorized: 'Acceso no autorizado',
    uppercase: '1 mayúscula',
    verificationEmailSent: '¡Email de verificación enviado!',
    verificationTimeout: 'La verificación tardó demasiado. Por favor inténtelo de nuevo.',
    verifyingLink: 'Verificando su enlace de inicio de sesión'
  },

  // Dashboard
  dashboard: {
    title: 'Panel de control',
    welcome: 'Bienvenido, {name}',
    overview: 'Resumen',
    recentScans: 'Escaneos recientes',
    statistics: 'Estadísticas',
    quickActions: 'Acciones rápidas',
    newScan: 'Nuevo escaneo',
    viewAllScans: 'Ver todos los escaneos',
    totalScans: 'Total de escaneos',
    activeScans: 'Escaneos activos',
    completedScans: 'Escaneos completados',
    failedScans: 'Escaneos fallidos',
    vulnerabilitiesFound: 'Vulnerabilidades encontradas',
    criticalVulns: 'Vulnerabilidades críticas',
    highVulns: 'Vulnerabilidades altas',
    mediumVulns: 'Vulnerabilidades medias',
    lowVulns: 'Vulnerabilidades bajas',
    systemHealth: 'Estado del sistema',
    toolsStatus: 'Estado de herramientas',
    cpuUsage: 'Uso de CPU',
    memoryUsage: 'Uso de memoria',
    diskUsage: 'Uso de disco',
    monitoring: 'Monitoreo y análisis de seguridad en tiempo real',
    critical: 'crit',
    serverPerformance: 'Rendimiento del servidor',
    realtimeMonitoring: 'Monitoreo en tiempo real de los recursos del sistema',
    online: 'En línea',
    scansToday: 'Escaneos hoy',
    networkLoad: 'Carga de red',
    temperature: 'Temperatura',
    noActiveScans: 'Sin escaneos activos. Inicie un nuevo escaneo para comenzar.',
    noRecentActivity: 'Sin actividad reciente.',
    startAssessment: 'Iniciar una evaluación de seguridad',
    exportResults: 'Exportar los resultados de escaneos',
    infrastructureTotal: 'Infraestructura total',
    // Service status
    services: {
      backendApi: 'Servidor Backend',
      frontend: 'Interfaz',
      postgresql: 'PostgreSQL',
      aiModels: 'Modelos IA'
    },
    serviceStatus: {
      online: 'En línea',
      offline: 'Fuera de línea',
      checking: 'Verificando',
      degraded: 'Degradado'
    },
    attackTools: {
      reconnaissance: 'Reconocimiento',
      exploitation: 'Explotación',
      bruteForce: 'Fuerza bruta',
      postExploitation: 'Post-Explotación',
      privilegeEscalation: 'Escalada de privilegios'
    },
    targets: {
      webApps: 'Aplicaciones web',
      servers: 'Servidores',
      databases: 'Bases de datos',
      network: 'Red',
      networkDevices: 'Routers, switches',
      target: 'Objetivo'
    },
    resources: {
      high: 'Alto',
      medium: 'Medio',
      normal: 'Normal',
      critical: 'Crítico',
      optimal: 'Óptimo',
      active: 'Activo',
      inUse: 'En uso',
      idle: 'En espera',
      notDetected: 'No detectado',
      gpuNotAvailable: 'GPU no disponible',
      aiDisabled: 'IA desactivada',
      cores: 'núcleos',
      multiCore: 'Multi-núcleo',
      systemLoad: 'Carga del sistema',
      used: 'usados',
      calculating: 'Calculando...',
      total: 'total',
      totalCores: 'Núcleos totales',
      totalMemory: 'RAM total',
      computePower: 'Potencia de cálculo',
      ramCapacity: 'Capacidad de memoria',
      aiCapacity: 'Capacidad IA',
      availableTotal: 'Disponible / Total',
      cpuCores: 'Núcleos CPU',
      ramInfra: 'RAM Infra.',
      gpuVram: 'VRAM GPU',
      aiReady: 'IA Lista',
      servers: 'servidores',
      onlineCount: 'en línea',
      offlineCount: 'fuera de línea',
      gpuOnline: 'GPU en línea',
      model: 'modelo',
      temperatureOk: 'OK'
    },
    recentActivity: 'Actividad reciente',
    uptime: 'Tiempo de actividad',
    activeProcesses: 'Procesos activos',
    started: 'Iniciado'
  },

  // Scans
  scans: {
    title: 'Escaneos',
    newScan: 'Nuevo escaneo',
    scanHistory: 'Historial de escaneos',
    target: 'Objetivo',
    targets: 'Objetivos',
    scanType: 'Tipo de escaneo',
    startScan: 'Iniciar escaneo',
    stopScan: 'Detener escaneo',
    pauseScan: 'Pausar',
    resumeScan: 'Reanudar',
    deleteScan: 'Eliminar escaneo',
    scanDetails: 'Detalles del escaneo',
    scanResults: 'Resultados del escaneo',
    progress: 'Progreso',
    duration: 'Duración',
    startedAt: 'Iniciado el',
    completedAt: 'Completado el',
    status: {
      waiting: 'En cola',
      pending: 'Pendiente',
      running: 'En ejecución',
      completed: 'Completado',
      failed: 'Fallido',
      cancelled: 'Cancelado',
      paused: 'Pausado'
    },
    types: {
      quick: 'Escaneo rápido',
      full: 'Escaneo completo',
      stealth: 'Escaneo sigiloso',
      aggressive: 'Escaneo agresivo',
      custom: 'Escaneo personalizado',
      iot_scan: 'Escaneo IoT',
      ot_scan: 'Escaneo OT/SCADA',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      network_discovery: 'Descubrimiento de red',
      vulnerability_scan: 'Escaneo de vulnerabilidades',
      expert: 'Escaneo experto',
      api_pentest: 'Pentest API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Escaneo Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Ingeniería social',
      red_team: 'Red Team',
      phishing: 'Campaña de phishing'
    },
    phases: {
      discovery: 'Descubrimiento',
      portScan: 'Escaneo de puertos',
      serviceDetection: 'Detección de servicios',
      vulnScan: 'Escaneo de vulnerabilidades',
      exploitation: 'Explotación',
      reporting: 'Informe'
    },
    stealthMode: {
      title: 'Modo Sigiloso',
      description: 'Técnicas de evasión IDS/IPS',
      none: 'Ninguno',
      noneDesc: 'Escaneo rápido, fácilmente detectable',
      basic: 'Básico',
      basicDesc: 'Paquetes fragmentados',
      advanced: 'Avanzado',
      advancedDesc: 'Temporización lenta + spoofing',
      paranoid: 'Paranoico',
      paranoidDesc: 'Evasión máxima (muy lento)',
      warning: 'Los modos sigilosos utilizan técnicas de evasión para evitar la detección IDS/IPS'
    },
    hosts: 'Hosts',
    ports: 'Puertos',
    services: 'Servicios',
    openPorts: 'Puertos abiertos',
    closedPorts: 'Puertos cerrados',
    filteredPorts: 'Puertos filtrados',
    noResults: 'No se encontraron resultados',
    exportResults: 'Exportar resultados',
    scanFailed: 'Escaneo fallido',
    genericError: 'Se produjo un error durante la ejecución del escaneo. Esto puede deberse a problemas de conectividad de red, objetivos inaccesibles o recursos insuficientes.',
    technicalDetails: 'Detalles técnicos',
    retryScan: 'Reintentar este escaneo',
    // Cleanup mode
    cleanup: 'Limpieza',
    cleanupTitle: 'Limpieza post-pentest',
    cleanupDescription: 'Esta acción eliminará todos los rastros dejados por el pentest, incluyendo:',
    cleanupSessions: 'Sesiones de explotación activas',
    cleanupPersistence: 'Mecanismos de persistencia instalados',
    cleanupFiles: 'Archivos temporales y evidencias',
    cleanupLogs: 'Registros de ejecución APT',
    cleanupPreview: 'Vista previa de limpieza',
    sessionsCount: 'Sesiones',
    withPersistence: 'Con persistencia',
    aptExecutions: 'Ejecuciones APT',
    evidenceFiles: 'Archivos de evidencia',
    evidenceSize: 'Tamaño de evidencia',
    cleanNow: 'Limpiar ahora',
    archiveAndClean: 'Archivar y limpiar',
    cleaning: 'Limpiando...',
    cleanupSuccess: 'Limpieza completada con éxito',
    cleanupPartial: 'Limpieza parcial (algunos errores)',
    cleanupFailed: 'Limpieza fallida',
    sessionsClosed: 'Sesiones cerradas',
    persistenceRemoved: 'Persistencia eliminada',
    filesCleaned: 'Archivos limpiados',
    aptLogsCleaned: 'Registros APT limpiados',
    evidenceArchived: 'Evidencia archivada',
    cleanupWarning: '⚠️ Esta acción es irreversible. Asegúrese de haber guardado los datos importantes.',
    status: {
      queued: 'En cola',
      stopped: 'Detenido',
      scheduled: 'Planificado',
    },
    filters: {
      all: 'Todos',
      failed: 'Fallidos',
    },
    types: {
      ai_scan: 'Escaneo IA',
      cloud_scan: 'Escaneo Cloud',
    },
    stealthMode: {
      basicTime: 'El escaneo tardará aproximadamente 2x más',
      advancedTime: 'El escaneo tardará aproximadamente 5x más',
      paranoidTime: 'El escaneo tardará aproximadamente 10x más',
    },
    advancedDiscoveryOptions: 'Opciones de descubrimiento avanzadas',
    configureScan: 'Configurar los parámetros detallados del escaneo',
    steps: {
      targetType: 'Objetivo y Tipo',
      networkMode: 'Modo de Red',
      scanOptions: 'Opciones',
      advanced: 'Avanzado',
      review: 'Verificación',
    },
    allScans: 'Total',
    activeScans: 'Escaneos activos',
    withSuccess: 'Completados con éxito',
    vulnerabilities: 'Vulnerabilidades',
    discovered: 'Hosts detectados',
    toReview: 'A revisar',
    sortByDate: 'Ordenar por fecha',
    sortByStatus: 'Ordenar por estado',
    sortByVulns: 'Ordenar por vuln.',
    tooltips: {
      totalScans: 'Total de Escaneos',
      totalScansDesc: 'Número total de escaneos lanzados en la plataforma. Incluye todos los escaneos: en curso, terminados y fallidos.',
      runningScans: 'Escaneos en Curso',
      runningScansDesc: 'Escaneos actualmente en ejecución. Analizan los objetivos para detectar puertos abiertos, servicios y vulnerabilidades.',
      completedScans: 'Escaneos Completados',
      completedScansDesc: 'Escaneos que se han completado con éxito. Los resultados están disponibles para consulta y exportación en los informes.',
      vulnerabilities: 'Vulnerabilidades Detectadas',
      vulnerabilitiesDesc: 'Total de fallas de seguridad identificadas. Las insignias indican el número de vulnerabilidades críticas y altas que requieren atención inmediata.',
      hostsDiscovered: 'Hosts Descubiertos',
      hostsDiscoveredDesc: 'Número de máquinas (servidores, puestos, equipos de red) detectadas durante los escaneos. Cada host puede tener varios puertos y servicios expuestos.',
      failedScans: 'Escaneos Fallidos',
      failedScansDesc: 'Escaneos fallidos (objetivo inaccesible, timeout, problema de red). Consulte los detalles para entender la causa y relanzar si es necesario.',
    },
    notFound: 'Escaneo no encontrado',
    notFoundDesc: 'El escaneo solicitado no existe o ha sido eliminado',
    backToScans: 'Volver a los escaneos',
    consoleLive: 'Consola en directo',
    consoleCompleted: 'Consola (Completado)',
    consoleFailed: 'Consola (Fallido)',
    consoleTitle: 'Consola',
    scanCompletedMessage: '✓ ¡Completado!',
    scanFailedMessage: '✗ Escaneo fallido',
    stepCompleted: 'Completado',
    stepWaiting: 'En espera',
    stepInProgress: 'Escaneo en curso',
    timestampStarted: 'Iniciado',
    timestampCompleted: 'Completado',
    aiQuotaExceeded: 'Cuota de escaneos IA alcanzada',
    aiScansUsed: 'Escaneos IA usados',
    upgradeOptions: 'Opciones para continuar',
    callSylink: 'Llame al servicio de atención al cliente SYLink:',
    upgradePlan: 'Pase a un plan superior para escaneos IA ilimitados',
    viewPlans: 'Ver los planes',
    networkDiscovery: 'Descubrimiento de Red',
    networkDiscoveryDesc: 'Descubrimiento rápido de hosts y puertos',
    vulnerabilityScan: 'Escaneo de Vulnerabilidades',
    vulnerabilityScanDesc: 'Análisis profundo de vulnerabilidades',
    fullAutonomous: 'Autónomo completo',
    fullAutonomousDesc: 'Evaluación de seguridad completa',
    placeholders: {
      target: '192.168.1.0/24 o ejemplo.com',
      targetExamples: 'Ejemplos: 192.168.1.1, 192.168.1.0/24, ejemplo.com, 10.0.0.0/8',
      customPorts: 'Ej: 80,443,8080-8090',
      excludeHosts: 'Ej: 192.168.1.1,192.168.1.5',
    },
    searchPlaceholder: 'Buscar por Objetivo o Tipo...',
    table: {
      name: 'Nombre',
      score: 'Puntuación',
      target: 'Objetivo',
      client: 'Cliente',
      type: 'Tipo',
      status: 'Estado',
      vulnerabilities: 'Vuln.',
      date: 'Fecha',
      actions: 'Acciones',
    },
    noCaptures: 'Sin capturas',
    noLogsAvailable: 'Sin registros disponibles',
    waitingForLogs: 'Esperando registros...',
    discoveringHosts: 'Descubrimiento de hosts en curso...',
    noHostDiscovered: 'Ningún host descubierto',
    analyzingVulns: 'Análisis de vulnerabilidades en curso...',
    noVulnDetected: 'Ninguna vulnerabilidad detectada',
    noCriticalVulns: 'Ninguna vulnerabilidad crítica detectada.',
    noAttackScenario: 'Ningún escenario de ataque crítico identificado.',
    noWeakness: 'Ninguna debilidad crítica detectada',
    noContent: 'Sin contenido disponible',
    noData: 'Sin datos disponibles',
    noVpnSession: 'Ninguna sesión VPN está actualmente activa para este workspace.',
    loadingExecutiveReport: 'Cargando el informe ejecutivo...',
    saveSchedule: 'Guardar la programación',
    noActiveScan: 'Ningún escaneo en curso',
    noScanFound: 'Ningún escaneo encontrado',
    noScanResult: 'Sin resultados para "{query}"',
    noScanStatus: 'Sin escaneos con el estado "{status}"',
    noVulnerabilities: 'Sin vulnerabilidades',
    loadingError: 'Error de carga',
    deleteFailedScans: 'Eliminar los fallidos',
    deleteFailedScansTitle: 'Eliminar todos los escaneos fallidos',
    confirmDeleteFailed: '¿Eliminar los {count} escaneo(s) fallido(s)?',
    deleteScansError: 'Error al eliminar los escaneos',
    associateScansError: 'Error al asociar los escaneos',
    removeScansError: 'Error al retirar el escaneo',
    restartScansError: 'Error al relanzar los escaneos',
    restartError: 'Error al relanzar',
    loadScansError: 'Error al cargar los escaneos',
    networkError: 'Error de red. Verifique su conexión e inténtelo de nuevo.',
    validateScansError: 'Error al validar los escaneos',
    imageLoadError: 'Error al cargar la imagen',
    noWorkspaceForScan: 'Ningún workspace asociado a este escaneo. Por favor seleccione un cliente desde la página Clientes, luego relance el escaneo.',
    pdfGenerationError: 'Error generación PDF',
    scheduleSaved: 'Guardar la programación',
    scheduleError: 'Error al crear la programación',
    generatePdfError: 'Error al generar el PDF',
    errors: {
      createFailed: 'Error al crear el escaneo',
      serverError: 'Error del servidor durante el escaneo',
      workspaceRequired: 'Se requiere workspace para iniciar un escaneo'
    },
    screenshotLoadError: 'Error al cargar la captura',
  },

  // Workspaces
  workspaces: {
    title: 'Espacios de clientes',
    newWorkspace: 'Nuevo espacio',
    editWorkspace: 'Editar espacio',
    deleteWorkspace: 'Eliminar espacio',
    workspaceDetails: 'Detalles del espacio',
    clientName: 'Nombre del cliente',
    clientInfo: 'Información del cliente',
    members: 'Miembros',
    addMember: 'Añadir miembro',
    removeMember: 'Eliminar miembro',
    scansCount: 'Número de escaneos',
    lastActivity: 'Última actividad',
    created: 'Creado el',
    shareWorkspace: 'Compartir espacio',
    archiveWorkspace: 'Archivar espacio',
    noWorkspaces: 'Sin espacios de clientes',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'Ej: 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Ej: 123 456 789',
    // Additional workspace keys
    scans: 'Escaneos',
    hosts: 'Hosts',
    vulnerabilities: 'Vulnerabilidades',
    attackPaths: 'Rutas de ataque',
    successfulScans: 'Escaneos exitosos',
    company: 'Empresa',
    legalForm: 'Forma jurídica',
    address: 'Dirección',
    city: 'Ciudad',
    website: 'Sitio web',
    shareDescription: 'Comparte este espacio con tus clientes o colaboradores',
    manageShares: 'Gestionar comparticiones',
    mainContact: 'Contacto principal',
    contact: 'Contacto',
    signed: 'Firmado',
    pending: 'Pendiente',
    draft: 'Borrador',
    contractSigned: 'Contrato firmado',
    pendingContract: 'Contrato pendiente',
    noContract: 'Sin contrato',
    noScans: 'Sin escaneos asociados',
    noScansHint: 'Asocie un escaneo existente o inicie uno nuevo desde la página Escaneos',
    noHosts: 'Sin hosts',
    noVulnerabilities: 'Sin vulnerabilidades',
    noAttackPaths: 'Sin rutas de ataque',
    // Network stats
    vulnerable: 'Vulnerables',
    subnets: 'Subredes',
    services: 'Servicios',
    noAttackTree: 'Sin árbol de ataque',
    noVPN: 'Sin VPN configurado',
    // AI Analysis
    aiAnalysis: 'Análisis IA',
    generateSummary: 'Generar resumen',
    launchAiAnalysis: 'Lanzar análisis IA',
    analysisInProgress: 'Análisis en curso...',
    completeAnalysis: 'Análisis completo y Soluciones',
    aggregatedData: 'Datos agregados',
    riskAnalysis: 'Análisis de riesgos',
    clickToGenerateSummary: 'Haz clic en "Generar resumen" para obtener un análisis IA',
    noAnalysisAvailable: 'Ningún análisis disponible',
    clickToLaunchAnalysis: 'Haz clic en el botón de arriba para lanzar el análisis IA',
    launchScanToDiscoverNetwork: 'Lanza un escaneo para descubrir la red',
    critical: 'Críticos',
    high: 'Altos',
    download: 'Descargar',
    deleteStoredCredentials: 'Eliminar credenciales guardadas',
    useStoredCredentials: 'usar credenciales guardadas',
    enterVpnUsername: 'Introduce tu usuario VPN',
    enterVpnPassword: 'Introduce tu contraseña VPN',
    // VPN Modal
    actionPlan: 'Plan de acción y Soluciones',
    noDocuments: 'Ningún documento generado para este workspace',
    reportsWillAppear: 'Los informes aparecerán aquí después de la generación',
    vpnCredentials: 'Credenciales VPN',
    requiresAuthentication: 'requiere autenticación',
    storedCredentials: 'Credenciales guardadas',
    clickToUseCredentials: 'Haz clic en "Conectar" para usar estas credenciales',
    connect: 'Conectar',
    cancel: 'Cancelar',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    saveCredentials: 'Guardar estas credenciales',
    saveCredentialsSecurely: 'Guardar credenciales de forma segura',
    credentialsStorageInfo: 'Las credenciales se cifrarán (AES-256) y se almacenarán en la base de datos. Se utilizarán automáticamente en futuras conexiones VPN.',
    saving: 'Guardando...',
    connecting: 'Conectando...',
    server: 'Servidor',
    protocol: 'Protocolo',
    noVulnsToFix: 'No hay vulnerabilidades que corregir',
    connectionInProgress: 'Conexión en curso...',
    connectionFailed: 'Conexión fallida',
    generateActionPlan: 'Generar plan de acción',
    clickToGenerateActionPlan: 'Haz clic en "Generar plan de acción" para obtener recomendaciones',
    vpnConnected: '¡VPN conectada! IP:',

    // Workspace Switcher
    selectTitle: 'Seleccionar espacio de trabajo',
    selectDescription: 'Elige un espacio de trabajo para continuar',
    searchPlaceholder: 'Buscar espacios de trabajo...',
    noWorkspacesYet: 'Aún no hay espacios de trabajo',
    noResults: 'No hay espacios de trabajo coincidentes',
    createFirst: 'Crear tu primer espacio de trabajo',
    createNew: 'Crear nuevo',
    continue: 'Continuar',
    switchError: 'Error al cambiar de espacio de trabajo',
    scan: 'escaneo',
    scans: 'escaneos',
    select: 'Seleccionar espacio de trabajo',
    manageAll: 'Gestionar espacios de trabajo',
    noWorkspaces: 'No se encontraron espacios de trabajo',
    switching: 'Cambiando...',
    switchSuccess: 'Espacio de trabajo cambiado exitosamente',
    autoSelected: 'Espacio de trabajo seleccionado automáticamente',
    pleaseSelect: 'Por favor selecciona un espacio de trabajo para continuar',
    activeWorkspace: 'Espacio de trabajo activo',
    subtitle: 'Gestione sus espacios de clientes y sus configuraciones',
    deleteWorkspaceError: 'Error al eliminar el espacio',
    deleteWorkspaceSuccess: 'Espacio eliminado con éxito',
    invalidIdentifier: 'Por favor introduzca un identificador válido',
    workspaceName: 'Nombre del espacio',
    companyName: 'Nombre de la empresa',
    searchCompany: 'Buscar una empresa',
    postalCode: 'Código postal',
    nafCode: 'Código NAF',
    capital: 'Capital',
    employees: 'Efectivo',
    companyLogo: 'Logo de la empresa',
    noLogo: 'Sin logo',
    vpnConfiguration: 'Configuración VPN',
    contractStatus: 'Estado del contrato',
    sendContract: 'Enviar el contrato',
    readyForTests: 'Listo para las pruebas',
    upload: 'Subir',
    country: 'País',
    contractNotSigned: 'Contrato no firmado',
    analyzingInProgress: 'Análisis en curso...',
    generatingAiSummary: 'Generación del resumen IA',
    noScansToAssociate: 'No hay escaneos disponibles para asociar',
    associateScan: 'Asociar un escaneo',
    networkMap: 'Mapa de Red',
    // Contact form labels
    contactFullName: 'Nombre completo',
    contactFunction: 'Función',
    contactEmail: 'Correo electrónico',
    contactPhone: 'Teléfono',
    contactResponsibleDescription: 'Persona responsable del proyecto pentest',
    logoUsedInReports: 'Utilizado en los informes de pentest',
    // Schedules
    scanSchedules: 'Planificaciones de escaneo',
    addSchedule: 'Añadir planificación',
    noSchedules: 'Sin planificaciones configuradas',
    noSchedulesHint: 'Haga clic en "Añadir planificación" para automatizar sus escaneos',
    createSchedule: 'Crear planificación',
    scheduleName: 'Nombre de la planificación',
    scheduleNamePlaceholder: 'Ej: Escaneo semanal de seguridad',
    targets: 'Objetivos',
    targetsPlaceholder: '192.168.1.0/24, ejemplo.com',
    targetsCommaSeparated: 'Objetivos * (separados por comas)',
    scanType: 'Tipo de escaneo',
    frequency: 'Frecuencia',
    timeOfDay: 'Hora de ejecución',
    daysOfWeek: 'Días de la semana',
    autoGenerateReport: 'Generar el informe automáticamente',
    sendNotifications: 'Enviar notificaciones',
    notificationRecipients: 'Destinatarios de notificaciones (correos, separados por comas)',
    creating: 'Creando...',
    // Scan types
    scanTypeQuick: 'Rápido',
    scanTypeFull: 'Completo',
    scanTypeVulnerability: 'Vulnerabilidades',
    scanTypePortScan: 'Escaneo de puertos',
    scanTypeWebScan: 'Escaneo Web',
    // Frequencies
    frequencyDaily: 'Diario',
    frequencyWeekly: 'Semanal',
    frequencyBiweekly: 'Bimensual',
    frequencyMonthly: 'Mensual',
    frequencyQuarterly: 'Trimestral',
    // Days
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mié',
    dayThu: 'Jue',
    dayFri: 'Vie',
    daySat: 'Sáb',
    daySun: 'Dom',
    // Stats labels
    schedulesCount: 'Planificaciones',
    successfulRuns: 'Ejecuciones exitosas',
    runNow: 'Ejecutar ahora',
    nextRun: 'Próxima',
    // Remediation Tracker
    remediationTitle: 'Seguimiento de Remediación',
    remediationProgress: 'Progreso global',
    remediationVulnsFixed: 'vulnerabilidades remediadas',
    remediationNoVulns: 'No se encontraron vulnerabilidades',
    remediationRescanTitle: 'Lanzar un re-escaneo de verificación',
    remediationAllStatuses: 'Todos los estados',
    remediationAllSeverities: 'Todas las severidades',
    remediationResults: 'resultados',
    remediationSeverity: 'Severidad',
    remediationVulnerability: 'Vulnerabilidad',
    remediationHost: 'Host',
    remediationStatus: 'Estado',
    remediationUpdated: 'Actualizado',
    remediationActions: 'Acciones',
    remediationPrevious: '← Anterior',
    remediationNext: 'Siguiente →',
    remediationCritical: 'Crítica / Alta — sin tratar',
    remediationSeverityBreakdown: 'Desglose por severidad',
    remediationStatusUpdate: 'Estado actualizado',
    remediationStatusError: 'Error al actualizar',
    remediationLoadDashboardError: 'Error al cargar el panel',
    remediationLoadVulnsError: 'Error al cargar vulnerabilidades',
    remediationRefresh: 'Actualizar',
    remediationCertificate: 'Certificado de cierre',
    remediationSearch: 'Buscar...',
    // Status labels
    statusOpen: 'Abierta',
    statusInProgress: 'En curso',
    statusFixed: 'Corregida (a verificar)',
    statusVerified: 'Verificada ✓',
    statusAcceptedRisk: 'Riesgo aceptado',
    statusWontFix: 'No se corregirá',
    // Severity labels
    severityCritical: 'Crítica',
    severityHigh: 'Alta',
    severityMedium: 'Media',
    severityLow: 'Baja',
    severityInfo: 'Info',
    // KPI labels
    kpiOpen: 'Abiertas',
    kpiInProgress: 'En curso',
    kpiToVerify: 'A verificar',
    kpiVerified: 'Verificadas',
    kpiAcceptedRisk: 'Riesgo aceptado',
    kpiTotal: 'Total',
    // VPN
    saveUid: 'Guardar el UID',
    noVpnCredentials: 'Sin credenciales VPN guardadas - conéctese para guardar',
    noVpnRoutes: 'Sin rutas personalizadas configuradas',
    add: 'Añadir',
    noScanReports: 'Sin informes de escaneo disponibles',
    errorAnalysis: 'Error de análisis',
    noBusinessAnalysis: 'Sin análisis de negocio disponible',
    noVpnConfig: 'Sin configuración VPN',
    deleteReport: 'Eliminar el informe',
    vpnRouteCount: '{{count}} ruta(s)',
    noRoutes: 'Sin rutas',
    // WorkspaceManager
    deleteVpnLogo: 'Eliminar el logo',
    modifyWorkspace: 'Modificar el workspace',
    modifyWorkspaceDesc: 'Modificar la información del cliente "{{name}}"',
    modifyVpnDesc: 'Modificar el VPN asociado para los escaneos de este cliente',
    noVpnRequired: 'Sin configuración VPN requerida',
    noVpnAvailable: 'Sin configuración VPN disponible',
    createWorkspaceBtn: 'Crear el workspace',
    vpnUploadError: 'Error al subir el VPN',
    companyNotFound: 'Ninguna empresa encontrada para "{{term}}"',
    noCompanyFound: 'Ninguna empresa encontrada',
    companySearchError: 'Error durante la búsqueda',
    scheduleError: 'Error al planificar el escaneo',
    noCompletedScans: 'Sin escaneos completados',
    allWorkspaces: 'Todos los workspaces',
    contractCreateError: 'Error al crear el contrato',
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilidades',
    subtitle: 'Análisis y gestión de vulnerabilidades detectadas',
    vulnerability: 'Vulnerabilidad',
    severity: 'Severidad',
    severities: {
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
      info: 'Informativa'
    },
    cve: 'CVE',
    cvss: 'Puntuación CVSS',
    affected: 'Afectado',
    solution: 'Solución',
    references: 'Referencias',
    evidence: 'Evidencias',
    exploitable: 'Explotable',
    verified: 'Verificado',
    falsePositive: 'Falso positivo',
    validation: {
      confirmed: 'Confirmado explotable',
      theoretical: 'Teórico',
      not_exploitable: 'No explotable',
      unvalidated: 'No validado',
      poc_title: 'Prueba de Concepto',
      narrative: 'Narrativa de explotación',
      exploit_path: 'Ruta de explotación',
      prerequisites: 'Requisitos previos',
    },
    markAsFixed: 'Marcar como corregido',
    noVulnerabilities: 'No se encontraron vulnerabilidades',
    export: 'Exportar vulnerabilidades',
    distributionBySeverity: 'Distribución por Severidad',
    priority: {
      auto: 'Automático',
    },
    // Attack Chain
    attackChain: {
      title: 'Clasificación de Cadenas de Ataque',
      subtitle: 'Análisis de riesgos multi-vulnerabilidades para penetrar el objetivo',
      riskScore: 'Puntuación de riesgo',
      vulnCount: 'vulnerabilidades',
      attackPath: 'Ruta de ataque hacia el objetivo',
      // Chart
      chartTitle: 'Distribución de Vulnerabilidades',
      chartSubtitle: 'Análisis estadístico de CVE detectadas',
      bySeverity: 'Distribución por Severidad',
      keyMetrics: 'Métricas Clave',
      totalVulns: 'Total CVE',
      avgCvss: 'CVSS Promedio',
      criticalHigh: 'Crítico + Alto',
      affectedHosts: 'Hosts Afectados',
      topCves: 'Top CVE por CVSS',
      // Stages
      stages: {
        initialAccess: 'Acceso Inicial',
        privEscalation: 'Escalada de Privilegios',
        persistence: 'Persistencia',
        objective: 'Objetivo'
      },
      exploitVia: 'Explotación vía',
      escalationVia: 'Escalada vía',
      maintenanceVia: 'Persistencia vía',
      fullCompromise: 'Compromiso total del sistema',
      adminAccess: 'Acceso de administrador posible',
      initialSystemAccess: 'Acceso inicial al sistema',
      // Risk Factors
      riskFactors: 'Factores de riesgo',
      factors: {
        multiVuln: 'Multi-vulnerabilidades',
        multiVuln5: '{count} vulns encadenables',
        multiVuln3: '{count} vulns en este host',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potencial',
        authBypass: 'Bypass auth posible',
        privEsc: 'Escalada de privilegios',
        exposed: 'Servicios expuestos',
        highCvss: 'CVSS promedio {score}'
      },
      // Ratings
      ratingCritical: 'CRÍTICO',
      ratingHigh: 'ALTO',
      ratingMedium: 'MEDIO',
      ratingLow: 'BAJO',
      ratingSafe: 'SEGURO',
      // Details
      criticalPath: 'RUTA CRÍTICA',
      vulnsInChain: 'Vulnerabilidades en esta cadena',
      noChains: 'No se detectaron cadenas de ataque',
      noVulnsDesc: 'No se encontraron vulnerabilidades para analizar rutas de ataque.',
      viewDetails: 'Ver detalles',
      multiVulnWarning: 'Riesgo aumentado: múltiples vulnerabilidades encadenables',
      // Recommendations
      recommendation: 'Recomendación de explotación',
      recoCritical: 'Este objetivo presenta un riesgo crítico. La combinación de {count} vulnerabilidades permite el compromiso total del sistema. Prioridad máxima para remediación.',
      recoHigh: 'Alto riesgo de compromiso. Las vulnerabilidades combinadas ofrecen una ruta de ataque viable. Acción correctiva recomendada lo antes posible.',
      recoMedium: 'Riesgo moderado. Algunas vulnerabilidades podrían encadenarse para explotación. Monitorear y corregir según prioridad.',
      recoLow: 'Riesgo bajo. Las vulnerabilidades presentes tienen impacto limitado y son difíciles de explotar en cadena.',
      // Stats
      criticalPaths: 'Rutas Críticas',
      highRisk: 'Riesgo Alto',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hosts Analizados',
      avgScore: 'Puntuación Promedio',
      // Info
      infoText: 'Esta clasificación identifica los hosts más vulnerables analizando combinaciones de vulnerabilidades explotables para alcanzar el objetivo de penetración.',
      // Legend
      legendCritical: 'Crítico (80-100)',
      legendHigh: 'Alto (60-79)',
      legendMedium: 'Medio (40-59)',
      legendLow: 'Bajo (20-39)',
      legendSafe: 'Seguro (0-19)',
      analysisTitle: 'Análisis de Riesgos',
    },
    aiAssistant: 'Asistente IA',
    aiAssistantDesc: 'Analice y explote vulnerabilidades de forma autónoma',
    searchPlaceholder: 'Buscar por título, CVE, descripción...',
    noVulnerabilitiesFound: 'No se encontraron vulnerabilidades en los escaneos.',
    noVulnerabilitiesBySeverity: 'No se encontraron vulnerabilidades de severidad {severity}.',
    customActionPlaceholder: 'Ej: shell_inverso, extraccion_creds, puerta_trasera...',
    actionPanel: {
      title: 'Acciones sobre la vulnerabilidad',
    },
    prioritization: 'Priorización',
    prioritizationDesc: 'Urgencia y criticidad',
    exploitabilityLabel: 'Explotabilidad',
    exploitabilityDesc: 'Vulnerabilidades explotables',
    summaryLabel: 'Resumen',
    summaryDesc: 'Vista general',
    remediationLabel: 'Remediación',
    remediationDesc: 'Plan de corrección',
    aiQueryPlaceholder: 'Haga una pregunta sobre las vulnerabilidades...',
    analyzeBtn: 'Analizar',
    pocAutoTitle: 'PoC Auto - Generación y Ejecución',
    pocSelectVuln: 'Seleccionar una vulnerabilidad',
    noCriticalHighForPoC: 'No hay vulnerabilidades críticas/altas para PoC',
    pocGeneratedCode: 'Código PoC Generado',
    copyCta: 'Copiar',
    executeBtn: 'Ejecutar',
    executingBtn: 'Ejecutando...',
    pocGenerating: 'Generando el PoC...',
    pocSelectPrompt: 'Seleccione una vulnerabilidad para generar un PoC',
    pocResult: 'Resultado:',
    pocActionInProgress: 'Acción en curso...',
    hideAttackTree: 'Ocultar Árbol de Ataque',
    showAttackTree: 'Mostrar Árbol de Ataque',
    viewWorkspace: 'Ver Workspace',
    generatingAttackTree: 'Generando el árbol de ataque...',
    noAttackTreeData: 'No hay datos disponibles para el árbol de ataque',
    ensureWorkspaceHasScans: 'Asegúrese de que el workspace tenga escaneos con vulnerabilidades',
    pageOfTotal: 'Página {current} / {total} — {count} vulnerabilidades',
    prevPage: '← Anterior',
    nextPage: 'Siguiente →',
    quickActionsTitle: 'Acciones Rápidas',
    newScanBtn: 'Nuevo escaneo',
    generateReportBtn: 'Generar informe',
    exportJsonBtn: 'Exportar JSON',
    exportCsvBtn: 'Exportar CSV',
    aiAnalysisTitle: 'Análisis IA',
    selectedLabel: 'Seleccionado:',
    analyzingLabel: 'Analizando...',
    analyzeWithAI: 'Analizar con IA',
    impactLabel: 'Impacto',
    recommendationsLabel: 'Recomendaciones',
    selectVulnForAnalysis: 'Seleccione una vulnerabilidad para obtener un análisis IA detallado.',
    statisticsTitle: 'Estadísticas',
    cvssAvg: 'CVSS Promedio',
    exploitableCount: 'Explotables',
    hostsAffected: 'Hosts Afectados',
    actionsHistory: 'Historial de Acciones ({count})',
    clearHistory: 'Borrar historial',
    viewScan: 'Ver escaneo',
    addToReport: 'Añadir al informe',
    severityLabel: 'Severidad',
    cveLabel: 'CVE',
    cvssLabel: 'CVSS',
    targetLabel: 'Objetivo',
    actionsAvailable: 'Acciones disponibles',
    exploitAction: 'Explotación',
    exploitActionDesc: 'Intentar explotar esta vulnerabilidad para obtener acceso',
    injectionAction: 'Inyección',
    injectionActionDesc: 'Ejecutar una inyección (SQL, comando, XSS, etc.)',
    enumerationAction: 'Enumeración',
    enumerationActionDesc: 'Recopilar más información sobre esta falla',
    privescAction: 'Escalada',
    privescActionDesc: 'Intentar una escalada de privilegios',
    pivotAction: 'Pivote',
    pivotActionDesc: 'Pivotar hacia otros sistemas de la red',
    exfilAction: 'Extracción',
    exfilActionDesc: 'Extraer datos sensibles a través de esta falla',
    aiWizardBtn: 'Wizard IA',
    aiWizardDesc: 'La IA analiza el CVE y lanza el wizard de explotación adecuado',
    captureProofBtn: 'Capturar Prueba',
    captureProofDesc: 'Capturar una prueba de explotación para el informe',
    customActionTitle: 'Acción personalizada',
    executeAction: 'Ejecutar',
    actionsAutoIntegrated: 'Los resultados de las acciones se integrarán automáticamente en el informe del escaneo',
    editPriority: 'Editar Prioridad',
    autoSeverity: 'Severidad automática:',
    manualPriority: 'Prioridad manual',
    usesCVSS: 'Usa CVSS',
    priorityCritical: 'Crítica',
    priorityHigh: 'Alta',
    priorityMedium: 'Media',
    priorityLow: 'Baja',
    priorityInfo: 'Info',
    noteOptional: 'Nota (opcional)',
    explainPriorityChange: 'Explique por qué cambió la prioridad...',
    savePriority: 'Guardar',
    savingPriority: 'Guardando...',
    aiWizardTitle: 'Wizard IA - Análisis de Vulnerabilidad',
    wizardRecommended: 'Wizard recomendado por la IA',
    vulnSummaryTitle: 'Resumen de la vulnerabilidad',
    launchWizard: 'Lanzar {name}',
    orChooseWizard: 'O elegir otro wizard:',
    aiAnalyzing: 'Analizando con IA...',
    aiDeterminingWizard: 'La IA determina el mejor wizard de explotación',
    screenshotsTitle: 'Capturas de Prueba ({count})',
    noScreenshots: 'No hay capturas de prueba',
    screenshotsAutoAdded: 'Las capturas se añadirán automáticamente a los informes',
    wizardReasonAD: 'Esta vulnerabilidad está relacionada con Active Directory, Kerberos o servicios Windows. El wizard AD permite explotar fallas de autenticación y movimiento lateral.',
    wizardReasonAPI: 'Esta vulnerabilidad concierne a una API o servicio web. El wizard API permite probar endpoints, autenticación e inyecciones.',
    wizardReasonIoT: 'Esta vulnerabilidad afecta a un dispositivo IoT o protocolo industrial. El wizard IoT está especializado en el análisis de objetos conectados.',
    wizardReasonOT: 'Esta vulnerabilidad concierne a un sistema industrial o SCADA. El wizard OT está diseñado para el análisis seguro de entornos industriales.',
    wizardReasonExpert: 'Esta vulnerabilidad crítica requiere un análisis profundo. El modo Experto ofrece control total sobre las técnicas de explotación.',
    wizardReasonAI: 'La IA analizará esta vulnerabilidad y determinará automáticamente la mejor estrategia de explotación.',
    aiSummaryTemplate: 'Esta vulnerabilidad {severity} afecta a {target}. Potencialmente permite a un atacante explotar {title}.',
    aiImpactCritical: 'Impacto crítico en la confidencialidad e integridad del sistema',
    aiImpactHigh: 'Impacto alto - requiere atención inmediata',
    aiImpactMedium: 'Impacto moderado - corregir a la brevedad posible',
    aiImpactLow: 'Impacto bajo - monitorear',
    aiRec1: 'Aplicar los parches de seguridad disponibles',
    aiRec2: 'Restringir el acceso de red al servicio afectado',
    aiRec3: 'Implementar una supervisión reforzada',
    aiRec4CVE: 'Consultar los detalles del CVE: {cve_id}',
    aiRec4NoCVE: 'Realizar un análisis profundo',
    aiExploitHigh: 'Alta',
    aiExploitMedium: 'Media',
    aiExploitLow: 'Baja',
    aiExploitUnknown: 'No evaluada',
    aiVectorRemote: 'Red (Remoto)',
    aiVectorAdjacent: 'Adyacente',
    aiVectorLocal: 'Local',
    exploitabilityMetric: 'Explotabilidad',
    attackDifficulty: 'Dificultad de ataque',
    detectionRisk: 'Riesgo de detección',
    exploitMaturity: 'Madurez del exploit',
    riskAssessment: 'Evaluación del riesgo',
    aiRecommendations: 'Recomendaciones IA',
    aiAnalyzingVuln: 'La IA está analizando la vulnerabilidad...',
    clickToGetRecommendations: 'Haga clic en "Ver" para obtener las recomendaciones IA',
    autoAnalysisDesc: 'Análisis automático de vectores de ataque y estrategias de explotación',
    analyzeLabel: 'Analizando...',
    viewLabel: 'Ver',
    generateExploit: 'Generar',
    generatingExploit: 'Generando...',
    executeOnTarget: 'Ejecutar en objetivo',
    executingExploit: 'Ejecutando...',
    copyCode: 'Copiar',
    codeCopied: '¡Código copiado al portapapeles!',
    langLabel: 'Lenguaje:',
    targetLabel2: 'Objetivo:',
    aiGeneratingExploit: 'La IA genera un exploit personalizado...',
    aiExploitAnalysisDesc: 'Análisis del CVE, creación del payload, optimización...',
    clickGenerateExploit: 'Haga clic en "Generar" para crear un exploit IA personalizado',
    thenExecuteExploit: 'Luego "Ejecutar en objetivo" para lanzar el ataque',
    autoExploitGenDesc: 'Generación automática de código de explotación adaptado al objetivo',
    exploitProofs: 'Pruebas de Explotación ({count})',
    captureN: 'Captura {n}:',
    capturesEnregistrees: '{count} capturas de prueba registradas',
    exploitReussie: 'EXPLOTACIÓN EXITOSA',
    exploitEchec: 'FALLO',
    dureeDuration: 'Duración',
    exportPdf: 'Exportar PDF',
    impactAnalysis: 'Análisis de Impacto',
    accessVector: 'Vector de acceso',
    accessComplexity: 'Complejidad de acceso',
    requiredAuth: 'Autenticación requerida',
    userInteractionLabel: 'Interacción del usuario',
    confidentialityImpact: 'Impacto en confidencialidad',
    integrityImpact: 'Impacto en integridad',
    availabilityImpact: 'Impacto en disponibilidad',
    networkInternet: 'Red Internet',
    adjacentNetwork: 'Red Adyacente',
    localAccess: 'Acceso Local',
    complexityLow: 'Baja',
    complexityHigh: 'Alta',
    privNone: 'Ninguna',
    privLow: 'Privilegios bajos',
    privHigh: 'Privilegios altos',
    userInteractionNone: 'No requerida',
    userInteractionRequired: 'Requerida',
    impactFull: 'Completo',
    impactPartial: 'Parcial',
    impactNone: 'Ninguno',
    scoreCvss: 'Puntuación CVSS v3.1',
    detailsBtn: 'Detalles',
    launchBtn: 'Lanzar',
    relaunchBtn: 'Relanzar',
    analyzingLabel2: 'Analizando...',
    remediationRecommendedDelay: 'Plazo recomendado',
    remediationMaxWindow: 'Ventana máxima de corrección',
    remediationImpact: 'Impacto',
    remediationHighImpact: 'ALTO',
    remediationRestartRequired: 'Reinicio del servicio requerido',
    remediationStepsTitle: 'Pasos de remediación detallados',
    step1Title: 'Copia de seguridad y preparación',
    step1Desc: 'Antes de cualquier modificación, realice una copia de seguridad completa del sistema.',
    step1Li1: 'Verificar el espacio en disco disponible',
    step1Li2: 'Documentar la configuración actual',
    step1Li3: 'Notificar a los equipos implicados',
    step2Title: 'Actualización de Apache Struts',
    step2Desc: 'Descargue e instale la última versión segura de Apache Struts.',
    step2Warning: 'Atención: Verifique la compatibilidad con su aplicación antes de la actualización',
    step3Title: 'Configuración WAF',
    step3Desc: 'Implemente reglas WAF para bloquear los intentos de explotación OGNL.',
    step4Title: 'Hardening de la configuración',
    step4Desc: 'Refuerce la configuración de Struts para prevenir futuras vulnerabilidades.',
    step5Title: 'Reinicio y validación',
    step5Desc: 'Reinicie los servicios y valide que la corrección es efectiva.',
    step5Li1: 'Verificar que la aplicación arranca correctamente',
    step5Li2: 'Probar las funcionalidades críticas',
    step5Li3: 'Relanzar un escaneo de vulnerabilidades para confirmar',
    step6Title: 'Monitorización y vigilancia',
    step6Desc: 'Implemente una vigilancia continua para detectar intentos de explotación.',
    step6Li1: 'Configurar alertas IDS/IPS para patrones de ataque Struts',
    step6Li2: 'Activar el registro detallado de peticiones HTTP',
    step6Li3: 'Programar escaneos de vulnerabilidad regulares (semanales)',
    step6Li4: 'Suscribirse a los boletines de seguridad de Apache Struts',
    workaroundTitle: 'Solución temporal (si el parche no es posible)',
    workaroundDesc: 'Si la actualización inmediata no es posible, aplique estas medidas de mitigación:',
    workaround1: 'Bloquear el acceso externo al servicio (firewall/ACL)',
    workaround2: 'Implementar un proxy inverso con filtrado de cabeceras Content-Type',
    workaround3: 'Deshabilitar los endpoints REST no esenciales',
    workaround4: 'Activar el modo estricto del parser multipart',
    attackDetails: 'Detalles del Ataque',
    targetInfo: 'Objetivo',
    systemInfoTitle: 'Información del Sistema',
    hostnameLabel: 'Nombre de host',
    architectureLabel: 'Arquitectura',
    ipLabel: 'Dirección IP',
    initialUserLabel: 'Usuario inicial',
    privilegesObtained: 'Privilegios obtenidos',
    domainLabel: 'Dominio',
    exfiltratedData: 'Datos Exfiltrados ({count})',
    proofCaptures: 'Capturas de Prueba ({count})',
    aiResponsesCount: '{count} respuesta(s) IA',
    questionLabel: 'Pregunta:',
    discoveredField: 'Descubierto',
    aiExecAlert: 'Ejecución de recomendaciones IA en {host}:{port}\n\nTest de penetración automatizado lanzado\nEscaneo de vulnerabilidades en curso\nVerificación de vectores de ataque\n\nResultados disponibles en unos minutos...',
    exploitSearchAlert: 'Búsqueda y prueba de exploits en {host}:{port}\n\nConectando a Metasploit Framework\nEscaneando módulos aplicables\nPrueba automatizada de exploits\n\n3 exploits encontrados, prueba en curso...',
    exploitGenAlert: 'Generación y ejecución de exploit IA en {host}:{port}\n\nAnálisis de la vulnerabilidad\nGeneración del payload personalizado\nEjecución en el objetivo\n\nResultado: ¡Explotación exitosa!\nSesión establecida.',
    screenshotInitialConn: 'Conexión inicial',
    screenshotInitialConnDesc: 'Establecimiento de la conexión reverse shell',
    screenshotSysInfo: 'Información del sistema',
    screenshotSysInfoDesc: 'Recuperación de información del objetivo',
    screenshotFileAccess: 'Acceso a archivos',
    screenshotFileAccessDesc: 'Prueba de acceso al sistema de archivos',
    attackComplexity: 'Complejidad de ataque',
    attackVector: 'Vector de ataque',
    backToList: 'Volver a la lista',
    cvssMetrics: 'Métricas CVSS',
    exportCsv: 'Exportar CSV',
    exportJson: 'Exportar JSON',
    host: 'Host',
    immediateFix: 'Corrección inmediata',
    noCVE: 'Sin CVE',
    port: 'Puerto',
    privilegesRequired: 'Privilegios requeridos',
    remediation: 'Remediación',
    remediationSummary: 'Resumen de remediación',
    service: 'Servicio',
    sortByCvss: 'Ordenar por CVSS',
    sortBySeverity: 'Ordenar por severidad',
    userInteraction: 'Interacción del usuario',
    screenshotPrivEsc: 'Escalada de privilegios',
    screenshotPrivEscDesc: 'Intento de escalada de privilegios',
  },

  // Reports
  reports: {
    title: 'Informes',
    newReport: 'Nuevo informe',
    generateReport: 'Generar informe',
    downloadReport: 'Descargar informe',
    reportType: 'Tipo de informe',
    settings: 'Configuración',
    branding: 'Branding',
    types: {
      executive: 'Informe ejecutivo',
      technical: 'Informe técnico',
      compliance: 'Informe de cumplimiento',
      full: 'Informe completo',
      vulnerability_list: 'Informe de vulnerabilidades',
      redteam: 'Informe Red Team',
      retest: 'Informe de retest',
      multi_campaign: 'Informe multi-campaña',
      active_directory: 'Informe Active Directory',
      data_leak: 'Informe de fugas de datos',
      attack_surface: 'Informe de superficie de ataque'
    },
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Texto (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Incluir evidencias',
    includeRemediation: 'Incluir recomendaciones',
    generatedAt: 'Generado el',
    generatedBy: 'Generado por',
    noReports: 'Sin informes',
    // Export modal
    export: {
      title: 'Exportación',
      processing: 'Exportando...',
      generating: 'Generando archivo',
      takingLong: 'Esta operación está tardando más de lo esperado.',
      canWaitOrEmail: 'Puede esperar o cerrar esta ventana y le enviaremos un enlace por correo.',
      sendByEmail: 'Enviar por correo',
      continueWaiting: 'También puede seguir esperando, la descarga comenzará automáticamente.',
      emailSent: '¡Correo enviado!',
      emailSentDesc: 'Recibirá el enlace de descarga por correo en breve.',
      wordLocked: 'Disponible para planes Empresa y superiores'
    },
    typeDescriptions: {
      executive: 'Síntesis estratégica para el COMEX con indicadores clave y recomendaciones prioritarias',
      technical: 'Análisis completo de vulnerabilidades con detalles técnicos y remediaciones',
      vulnerability_list: 'Exportación estructurada para Jira, ServiceNow, GLPI',
      redteam: 'Escenario de ataque narrativo con mapeo MITRE ATT&CK',
      retest: 'Comparación antes/después de la corrección',
      multi_campaign: 'Vista consolidada de varios escaneos',
      active_directory: 'Auditoría AD, privilegios, GPO, delegaciones',
      data_leak: 'Detección de datos expuestos y credenciales',
      attack_surface: 'Cartografía de la exposición externa',
    },
    aiGenerated: 'Informes IA',
    generated: {
      title: 'Informes Generados por IA',
      subtitle: 'Informes profesionales generados por LLM',
      create: 'Crear un informe',
      createNew: 'Nuevo informe IA',
      selectType: 'Tipo de informe',
      selectScan: 'Seleccionar un escaneo',
      selectWorkspace: 'Seleccione un espacio de trabajo',
      selectFormat: 'Formato de salida',
      generating: 'Generación en curso...',
      regenerate: 'Regenerar',
      regenerateSection: 'Regenerar esta sección',
      export: 'Exportar',
      download: 'Descargar',
      delete: 'Eliminar',
      confirmDelete: '¿Está seguro de que desea eliminar este informe?',
      status: {
        pending: 'Pendiente',
        queued: 'En cola',
        generating: 'Generando',
        completed: 'Completado',
        failed: 'Fallido',
        cancelled: 'Cancelado',
      },
      sections: {
        executive_summary: 'Resumen ejecutivo',
        key_findings: 'Conclusiones principales',
        recommendations: 'Recomendaciones',
        technical_details: 'Detalles técnicos',
        vulnerability_analysis: 'Análisis de vulnerabilidades',
        risk_assessment: 'Evaluación de riesgos',
        remediation_plan: 'Plan de remediación',
        attack_narrative: 'Narrativa de ataque',
        mitre_mapping: 'Mapeo MITRE ATT&CK',
        timeline: 'Cronología',
        appendix: 'Anexos',
      },
      quality: {
        score: 'Puntuación de calidad',
        excellent: 'Excelente',
        good: 'Bueno',
        average: 'Medio',
        poor: 'Bajo',
      },
      noReports: 'Ningún informe generado',
      noReportsDesc: 'Cree su primer informe IA para empezar',
      totalReports: 'Total de informes',
      completedReports: 'Informes completados',
      averageQuality: 'Calidad media',
      lastGenerated: 'Último informe',
    },
    placeholders: {
      footerText: 'Ej: Documento confidencial - No distribuir',
      logoUrl: 'https://empresa.es/logo.png',
      contactEmail: 'contacto@empresa.es',
      sectionTitle: 'Título de la sección...',
      sectionDescription: 'Descripción (opcional)...',
      contentTemplate: 'Introduzca la plantilla de contenido (Markdown compatible)...\n\nVariables disponibles:\n{{scan.target}} - Objetivo del escaneo\n{{scan.date}} - Fecha del escaneo\n{{vulnerabilities.count}} - Número de vulnerabilidades\n{{vulnerabilities.critical}} - Vulnerabilidades críticas',
    },
    config: {
      title: 'Configuración',
      subtitle: 'Configure los tipos de informes disponibles y personalice su contenido',
      settingsTitle: 'Parámetros de los informes',
      brandingTitle: 'Imagen de marca de los informes',
      defaultLanguage: 'Idioma por defecto',
      confidentialityLevel: 'Nivel de confidencialidad',
      includeOptions: 'Opciones de inclusión',
      includeLogo: 'Incluir el logo',
      includeTableOfContents: 'Incluir el índice',
      includeAppendices: 'Incluir los anexos',
      includeMethodology: 'Incluir la metodología',
      footerTextLabel: 'Texto del pie de página',
      logoUrlLabel: 'URL del logo',
      primaryColor: 'Color principal',
      secondaryColor: 'Color secundario',
      companyInfo: 'Información de la empresa (para los informes)',
      companyName: 'Nombre de la empresa',
      address: 'Dirección',
      contactEmail: 'Correo electrónico de contacto',
      phone: 'Teléfono',
      website: 'Sitio web',
      sectionsTitle: 'Secciones del informe',
      addSection: 'Añadir una sección',
      noTypeSelected: 'Ningún tipo seleccionado',
      noTypeSelectedHint: 'Haga clic en un tipo de informe en la lista para mostrar y personalizar sus secciones',
      sectionRequired: 'Sección requerida',
      sectionActive: 'Activo',
      requiredBadge: 'Requerido',
      contentTemplateLabel: 'Plantilla de contenido (Markdown compatible)',
      clickToAddTemplate: 'Haga clic para añadir una plantilla de contenido...',
      markdownHint: 'Use Markdown para el formateo. Variables: {{variable}}',
      noReportTypes: 'Ningún tipo de informe disponible',
      loadError: 'Error al cargar el informe',
      loadingReport: 'Cargando el informe...',
      loadDataError: 'Error al cargar los datos',
      loadSectionsError: 'Error al cargar las secciones',
      deleteError: 'Error al eliminar',
      reorderError: 'Error al reordenar',
      addError: 'Error al añadir',
      updateError: 'Error al actualizar',
      saveError: 'Error al guardar',
      downloadError: 'Error al descargar',
      generateError: 'Error al generar el informe',
      regenerateError: 'Error al regenerar',
      noGeneratedFile: 'Ningún archivo generado',
      noScansAvailable: 'Ningún escaneo completado disponible para generar informes. Por favor realice un escaneo primero.',
      noVulnsDetected: 'Ninguna vulnerabilidad detectada en los escaneos. El plan de remediación estará vacío.',
      loadingPentests: 'Cargando los pentests...',
      noScanAvailable: '-- Ningún escaneo disponible --',
      networkError: 'Error de red. Verifique su conexión.',
    },
  },

  // Account
  account: {
    title: 'Mi cuenta',
    profile: 'Perfil',
    security: 'Seguridad',
    subscription: 'Suscripción',
    billing: 'Facturación',
    credits: 'Créditos',
    notifications: 'Notificaciones',
    integrations: 'Integraciones',
    referral: 'Referidos',
    activity: 'Actividad',
    contracts: 'Contratos',

    // Profile section
    profileSection: {
      title: 'Información del perfil',
      avatar: 'Foto de perfil',
      changeAvatar: 'Cambiar foto',
      removeAvatar: 'Eliminar foto',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      company: 'Empresa',
      position: 'Cargo',
      timezone: 'Zona horaria',
      language: 'Idioma del portal',
      languageDescription: 'Elige el idioma de visualización de la interfaz',
      updateSuccess: 'Perfil actualizado con éxito',
      updateError: 'Error al actualizar el perfil',
      languages: {
        fr: 'Francés',
        en: 'Inglés',
        es: 'Español',
        de: 'Alemán',
        it: 'Italiano',
        pt: 'Portugués'
      }
    },

    // Security section
    securitySection: {
      title: 'Seguridad de la cuenta',
      changePassword: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      passwordRequirements: 'La contraseña debe tener al menos 8 caracteres',
      twoFactorAuth: 'Autenticación de dos factores',
      enable2FA: 'Activar 2FA',
      disable2FA: 'Desactivar 2FA',
      twoFactorEnabled: '2FA activada',
      twoFactorDisabled: '2FA desactivada',
      activeSessions: 'Sesiones activas',
      revokeSession: 'Revocar sesión',
      revokeAllSessions: 'Revocar todas las sesiones',
      loginHistory: 'Historial de inicios de sesión',
      lastLogin: 'Último inicio de sesión',
      apiKeys: 'Claves API',
      generateApiKey: 'Generar clave API',
      deleteApiKey: 'Eliminar clave API',
      passwordsNoMatch: 'Las contraseñas no coinciden',
      passwordChanged: 'Contraseña cambiada',
      mfaConfigError: 'Error de configuración MFA',
      invalidCode: 'Código inválido',
      apiKeyGenerated: 'Clave API generada y copiada',
      confirmApiKeyGenerate: '¿Generar una nueva clave API? La anterior quedará invalidada.',
      enterMfaCode: 'Ingrese su código MFA para deshabilitar',
      passwordCopied: 'Contraseña copiada al portapapeles',
      generatePasswordFirst: 'Genere una contraseña y verifique su número de teléfono',
      smsSent: 'Contraseña enviada por SMS',
      smsError: 'Error al enviar el SMS',
      mfaEnabled: '2FA activada',
      mfaDisabled: '2FA desactivada',
      passwordApplied: 'Contraseña aplicada a los campos',
    },

    // Subscription section
    subscriptionSection: {
      title: 'Suscripción',
      currentPlan: 'Plan actual',
      planDetails: 'Detalles del plan',
      features: 'Funciones incluidas',
      usage: 'Uso',
      limits: 'Límites',
      renewalDate: 'Fecha de renovación',
      cancelSubscription: 'Cancelar suscripción',
      upgradePlan: 'Mejorar plan',
      downgradePlan: 'Reducir plan',
      plans: {
        free: 'Gratuito',
        pro: 'Pro',
        enterprise: 'Empresa',
        dedicated: 'Dedicado'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestión de créditos',
      subtitle: 'Gestione sus créditos, suscripciones y paquetes',
      balance: 'Saldo',
      totalCredits: 'Créditos totales',
      monthlyCredits: 'Créditos mensuales',
      packCredits: 'Créditos de paquete',
      usedThisMonth: 'Usados este mes',
      remaining: 'Restantes',
      buyCredits: 'Comprar créditos',
      creditHistory: 'Historial de créditos',
      transaction: 'Transacción',
      amount: 'Cantidad',
      creditCosts: 'Coste de operaciones',
      scanCost: 'Coste de escaneo',
      reportCost: 'Coste de informe',
      expires: 'Expira el',
      noExpiration: 'Sin expiración',
      currentPlan: 'Plan actual',
      statusActive: 'Activo',
      monthlyPlans: 'Planes mensuales',
      free: 'Gratuito',
      perMonth: '/mes',
      creditsPerMonth: 'créditos/mes',
      unlimitedWorkspaces: 'Espacios de cliente ilimitados',
      externalScans: 'Escaneos externos',
      internalScans: 'Escaneos internos',
      adScans: 'Escaneos Active Directory',
      select: 'Seleccionar',
      creditPacks: 'Paquetes de créditos',
      credits: 'créditos',
      validity: 'Validez',
      months: 'meses',
      buy: 'Comprar',
      scans: 'Escaneos',
      leakDetection: 'Detección de filtraciones',
      audits: 'Auditorías',
      reports: 'Informes',
      noTransactions: 'Sin transacciones',
      transactionHistory: 'Historial de transacciones',
      refresh: 'Actualizar',
      date: 'Fecha',
      type: 'Tipo',
      dashboard: 'Panel de control',
      plansAndPacks: 'Planes y Paquetes',
      history: 'Historial',
      errorOccurred: 'Ha ocurrido un error',
      creditsAvailable: 'créditos disponibles',
      confirmPlanChange: 'Confirmar cambio de plan',
      confirmPurchase: 'Confirmar la compra',
      planActiveImmediately: 'El plan estará activo inmediatamente',
      creditsAddedImmediately: 'Los créditos serán añadidos inmediatamente',
      cancel: 'Cancelar',
      processing: 'Procesando...',
      confirm: 'Confirmar',
      planSubscribed: 'Suscripción al plan {plan} realizada con éxito',
      packPurchased: 'Compra del paquete {pack} realizada con éxito',
      statusPremium: 'PREMIUM',
      statusExhausted: 'AGOTADO',
      statusCritical: 'CRÍTICO',
      statusLow: 'BAJO',
      unlimited: 'Ilimitado',
      totalBalance: 'Saldo total disponible',
      monthly: 'Mensuales',
      packs: 'Paquetes'
    },

    // Notifications section
    notificationsSection: {
      title: 'Preferencias de notificaciones',
      emailNotifications: 'Notificaciones por correo',
      pushNotifications: 'Notificaciones push',
      scanCompleted: 'Escaneo completado',
      scanFailed: 'Escaneo fallido',
      newVulnerability: 'Nueva vulnerabilidad crítica',
      reportReady: 'Informe listo',
      securityAlerts: 'Alertas de seguridad',
      weeklyDigest: 'Resumen semanal',
      marketingEmails: 'Correos de marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integraciones',
      connected: 'Conectado',
      notConnected: 'No conectado',
      configure: 'Configurar',
      disconnect: 'Desconectar',
      testConnection: 'Probar conexión',
      connectionSuccess: 'Conexión exitosa',
      connectionFailed: 'Conexión fallida',
      availableIntegrations: 'Integraciones disponibles',
      myIntegrations: 'Mis integraciones'
    },

    // Referral section
    referralSection: {
      title: 'Programa de referidos',
      referralLink: 'Enlace de referido',
      copyLink: 'Copiar enlace',
      shareLink: 'Compartir enlace',
      inviteFriends: 'Invitar amigos',
      referralStats: 'Estadísticas de referidos',
      totalReferrals: 'Total de referidos',
      pendingReferrals: 'Referidos pendientes',
      completedReferrals: 'Referidos completados',
      earnedCredits: 'Créditos ganados',
      inviteByEmail: 'Invitar por correo',
      contacts: 'Contactos invitados',
      rewards: 'Recompensas',
      leaderboard: 'Clasificación',
      inviteContact: 'Invitar un contacto',
      shareDescription: 'Comparte este enlace para invitar a nuevos usuarios',
      loading: 'Cargando...',
      yourLevel: 'Tu nivel',
      nextLevel: 'Siguiente nivel',
      creditsEarned: 'Créditos ganados',
      conversionFunnel: 'Embudo de conversión',
      invited: 'Invitados',
      clicked: 'Clicados',
      signedUp: 'Registrados',
      converted: 'Convertidos',
      clickRate: 'Tasa de clic',
      conversionRate: 'Tasa de conversión',
      perClick: 'Por clic',
      perSignup: 'Por registro',
      perProConversion: 'Por conversión Pro',
      noContacts: 'Ningún contacto invitado',
      inviteFirstContact: 'Invita tu primer contacto',
      contact: 'Contacto',
      creditsGenerated: 'Créditos generados',
      topReferrers: 'Top Referidores',
      rank: 'Posición',
      user: 'Usuario',
      tier: 'Nivel',
      referrals: 'Referidos',
      conversions: 'Conversiones',
      value: 'Valor',
      you: '(tú)',
      firstName: 'Nombre',
      lastName: 'Apellido',
      company: 'Empresa',
      sendInvitation: 'Enviar invitación',
      referralLinkCopied: '¡Enlace de referido copiado!',
      invitationSent: '¡Invitación enviada con éxito!',
      contactRemoved: 'Contacto eliminado',
      deleteContactConfirm: '¿Eliminar este contacto?',
      resendInvitation: 'Reenviar invitación',
      statusInvited: 'Invitado',
      statusClicked: 'Clicado',
      statusSignedUp: 'Registrado',
      statusConverted: 'Convertido',
      statusChurned: 'Abandonó',
      remainingToNextTier: 'restantes',
      errorSending: 'Error al enviar la invitación',
      errorResending: 'Error al reenviar la invitación',
      errorDeleting: 'Error al eliminar el contacto',
      planSubscribed: 'Suscripción al plan {plan} realizada con éxito',
      packPurchased: 'Compra del paquete {pack} realizada con éxito'
    },

    // Save buttons
    // Avatar section
    avatarSection: {
      invalidType: 'Por favor seleccione una imagen',
      tooLarge: 'La imagen no debe superar 2 MB',
      updateSuccess: 'Avatar actualizado',
      updateError: 'Error al actualizar el avatar',
      readError: 'Error al leer el archivo'
    },

    // Company section
    companySection: {
      title: 'Información de la empresa',
      logo: 'Logo de la empresa',
      name: 'Nombre de la empresa',
      legalForm: 'Forma jurídica',
      capital: 'Capital social',
      address: 'Dirección',
      city: 'Ciudad',
      postalCode: 'Código postal',
      country: 'País',
      timezone: 'Zona horaria (para los análisis)',
      legalRep: 'Representante legal',
      fullName: 'Nombre completo',
      updateSuccess: 'Información de la empresa actualizada',
      updateError: 'Error al guardar'
    },

    // Team section
    teamSection: {
      confirmRemove: '¿Está seguro de que desea eliminar a este miembro?',
      memberRemoved: 'Miembro eliminado'
    },

    // Logo section
    logoSection: {
      updated: 'Logo actualizado',
      updatedAV: 'Logo actualizado - Análisis antivirus OK',
      updateError: 'Error al actualizar el logo',
      deleted: 'Logo eliminado',
      deleteError: 'Error al eliminar el logo'
    },

    configuration: 'Configuración',
    team: 'Equipo',
    users: 'Usuarios',
    help: 'Ayuda',
    history: 'Historial',
    version: 'Versión',
    support: 'Soporte',
    reportTypes: 'Tipos de informes',
    loadError: 'Error al cargar la cuenta',
    saveAll: 'Guardar todo',
    saveProfile: 'Guardar perfil',
    saveCompany: 'Guardar empresa'
  },

  // Settings
  settings: {
    title: 'Configuración',
    general: 'General',
    tools: 'Herramientas',
    network: 'Red',
    advanced: 'Avanzado',

    generalSection: {
      title: 'Configuración general',
      defaultScanType: 'Tipo de escaneo predeterminado',
      defaultReportFormat: 'Formato de informe predeterminado',
      autoSaveReports: 'Guardar informes automáticamente',
      enableNotifications: 'Activar notificaciones',
      darkMode: 'Modo oscuro',
      compactView: 'Vista compacta'
    },

    toolsSection: {
      title: 'Configuración de herramientas',
      enabledTools: 'Herramientas habilitadas',
      toolSettings: 'Configuración de herramientas',
      timeout: 'Tiempo de espera',
      threads: 'Número de hilos',
      verbosity: 'Nivel de detalle'
    },

    networkSection: {
      title: 'Configuración de red',
      proxySettings: 'Configuración de proxy',
      vpnSettings: 'Configuración de VPN',
      dnsSettings: 'Configuración de DNS',
      useProxy: 'Usar proxy',
      proxyHost: 'Host del proxy',
      proxyPort: 'Puerto del proxy'
    },

    // Server status
    uptime: 'Tiempo de actividad'
  },

  // Admin
  admin: {
    title: 'Administración',
    users: 'Usuarios',
    companies: 'Empresas',
    system: 'Sistema',
    logs: 'Registros',
    maintenance: 'Mantenimiento',

    usersSection: {
      title: 'Gestión de usuarios',
      addUser: 'Añadir usuario',
      editUser: 'Editar usuario',
      deleteUser: 'Eliminar usuario',
      activateUser: 'Activar usuario',
      deactivateUser: 'Desactivar usuario',
      resetPassword: 'Restablecer contraseña',
      role: 'Rol',
      roles: {
        admin: 'Administrador',
        user: 'Usuario',
        viewer: 'Observador'
      },
      lastLogin: 'Último inicio de sesión',
      createdAt: 'Creado el',
      noUsers: 'Sin usuarios'
    },

    systemSection: {
      title: 'Sistema',
      systemInfo: 'Información del sistema',
      version: 'Versión',
      uptime: 'Tiempo de actividad',
      restart: 'Reiniciar',
      backup: 'Copia de seguridad',
      restore: 'Restaurar',
      update: 'Actualizar'
    }
  },

  // Errors
  errors: {
    generic: 'Ha ocurrido un error',
    notFound: 'Página no encontrada',
    unauthorized: 'Acceso no autorizado',
    forbidden: 'Acceso prohibido',
    serverError: 'Error del servidor',
    networkError: 'Error de red',
    timeout: 'Tiempo de espera agotado',
    validation: 'Error de validación',
    invalidEmail: 'Correo electrónico inválido',
    invalidPassword: 'Contraseña inválida',
    passwordMismatch: 'Las contraseñas no coinciden',
    requiredField: 'Este campo es requerido',
    minLength: 'Se requieren mínimo {min} caracteres',
    maxLength: 'Se permiten máximo {max} caracteres',
    fillAllFields: 'Por favor complete todos los campos requeridos',
    emailAlreadyUsed: 'Este email ya está en uso',
    companyAlreadyRegistered: 'Esta empresa ya está registrada',
    registrationError: 'Error durante el registro',
    genericError: 'Ocurrió un error inesperado',
    disposableEmailNotAllowed: 'Los emails temporales no están permitidos',
    personalEmailNotAllowed: 'El email {domain} no está permitido. Use un email profesional.',
    invalidResetLink: 'Este enlace de restablecimiento es inválido o ha expirado. Por favor, solicite un nuevo enlace.',
    resetLinkExpired: 'Este enlace de restablecimiento ha expirado. Por favor, solicite un nuevo enlace.',
    resetPasswordFailed: 'Error al restablecer la contraseña. Por favor, inténtelo de nuevo.',
    passwordCriteriaNotMet: 'La contraseña no cumple todos los criterios requeridos.',
    backendMessages: {
      'Workspace not found': 'Espacio de trabajo no encontrado',
      'Invalid signature token': 'Token de firma inválido',
      'Contract already signed': 'Contrato ya firmado',
      'Contract already pending signature. Cancel existing request first.': 'Contrato ya en espera de firma. Cancele primero la solicitud existente.',
      'Contract not yet signed': 'Contrato aún no firmado',
      'Signed contract file not found': 'Archivo del contrato firmado no encontrado',
      'Contract file not found on disk': 'Archivo del contrato no encontrado en el disco',
      'Contract already signed, cannot cancel': 'Contrato ya firmado, no se puede cancelar',
      'No pending signature request to cancel': 'No hay solicitud de firma pendiente para cancelar',
      'User not found': 'Usuario no encontrado',
      'Invalid credentials': 'Credenciales inválidas',
      'Access denied': 'Acceso denegado',
      'Permission denied': 'Permiso denegado',
      'Not found': 'No encontrado',
      'Bad request': 'Solicitud inválida',
      'Internal server error': 'Error interno del servidor',
      'Service unavailable': 'Servicio no disponible'
    },
    verificationFailed: 'La verificación del email ha fallado. El enlace puede haber expirado o ser inválido.',
    invalidVerificationLink: 'Este enlace de verificación es inválido o ha expirado. Por favor, solicite un nuevo enlace.',
    rateLimitExceeded: 'Demasiados intentos. Por favor, inténtelo de nuevo en unos minutos.',
    rateLimitEmail: 'Por favor, espere unos minutos antes de reenviar un email de verificación.',
    '401': {
      title: 'No Autorizado',
      subtitle: '¡Vaya! Debe iniciar sesión',
      description: 'Su sesión ha expirado o no está autenticado. Por favor, inicie sesión para acceder a esta página.',
      redirectText: 'Redirigiendo al inicio de sesión'
    },
    '403': {
      title: 'Acceso Denegado',
      subtitle: '¡Vaya! Acceso prohibido',
      description: 'No tiene los permisos necesarios para acceder a este recurso.',
      redirectText: 'Redirigiendo al panel de control'
    },
    '404': {
      title: 'Página No Encontrada',
      subtitle: '¡Vaya! Página no encontrada',
      description: 'La página que busca no existe o fue movida.',
      redirectText: 'Redirigiendo al panel de control'
    },
    '500': {
      title: 'Error del Servidor',
      subtitle: '¡Vaya! Ha ocurrido un error',
      description: 'El servidor encontró un error. Por favor, inténtelo de nuevo en unos instantes.',
      redirectText: 'Redirigiendo al panel de control'
    },
    '503': {
      title: 'Servicio No Disponible',
      subtitle: '¡Vaya! Servicio temporalmente no disponible',
      description: 'El servicio está temporalmente no disponible por mantenimiento. Por favor, inténtelo de nuevo en unos instantes.',
      redirectText: 'Redirigiendo al panel de control'
    },
    backToDashboard: 'Volver al Panel de control',
    retry: 'Reintentar',
    supportContact: 'Si el problema persiste, contacte al soporte técnico.',
    redirectingIn: 'en',
    seconds: 'segundos',
    error: 'Error',
    companyRequired: 'Debe pertenecer a una empresa para realizar esta acción',
    selectRequired: 'Por favor, realice una selección',
    sessionExpired: 'Sesión expirada. Por favor, vuelva a iniciar sesión.'
  },

  // Success messages
  success: {
    saved: 'Guardado con éxito',
    deleted: 'Eliminado con éxito',
    updated: 'Actualizado con éxito',
    created: 'Creado con éxito',
    copied: 'Copiado al portapapeles',
    sent: 'Enviado con éxito',
    uploaded: 'Subido con éxito'
  },

  // Time
  time: {
    now: 'Ahora',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
    ago: 'hace',
    in: 'en'
  },

  // Credentials
  credentials: {
    title: 'Credenciales',
    username: 'Usuario',
    password: 'Contraseña',
    hash: 'Hash',
    domain: 'Dominio',
    source: 'Fuente',
    foundAt: 'Encontrado el',
    noCredentials: 'No se encontraron credenciales',
    export: 'Exportar credenciales',
    addNumbers: 'Agregar números',
    addSpecialChars: 'Caracteres especiales',
    noPasswordSave: 'No hay contraseña para guardar',
    saveDictionaryError: 'Error al guardar el diccionario',
    loadDictionariesError: 'Error al cargar los diccionarios',
    loadDictionaryError: 'Error al cargar el diccionario',
    deleteError: 'Error al eliminar',
    downloadError: 'Error al descargar',
    searchError: 'Búsqueda fallida',
    validationError: 'Error de validación',
    noCredentialExport: 'No hay credenciales para exportar',
    noPasswordExport: 'No hay contraseñas para exportar',
    decryptError: 'Error al descifrar',
    noDictionarySaved: 'No hay diccionario guardado',
    noWorkspace: '-- Sin workspace --',
    noResult: 'Sin resultados',
    noResultMatch: 'Ninguna credencial coincide',
    noPasswordAvailable: 'No hay contraseña disponible'
  },

  // Sessions
  sessions: {
    title: 'Sesiones',
    sessionDetails: 'Detalles de sesión',
    activeSession: 'Sesión activa',
    closedSession: 'Sesión cerrada',
    sessionType: 'Tipo de sesión',
    target: 'Objetivo',
    startedAt: 'Iniciado en',
    endedAt: 'Finalizado en',
    duration: 'Duración',
    commands: 'Comandos',
    noSessions: 'Sin sesiones',
    closeSession: 'Cerrar sesión',
    quickActions: 'Acciones rápidas',
    quickCommands: 'Comandos rápidos',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Sesión',
    pageTitle: 'Sesiones de Explotación',
    pageDescription: 'Gestión de sesiones de explotación y accesos comprometidos',
    interactiveShell: 'Terminal interactivo',
    manualExploit: 'Manual',
    platform: 'Plataforma',
    platformUnknown: 'Desconocida',
    exploitUsed: 'Exploit utilizado',
    commandsExecuted: 'Comandos ejecutados',
    status: {
      active: 'Activa',
      inactive: 'Inactiva',
      closed: 'Cerrada',
      stale: 'A relanzar',
      idle: 'En espera',
      error: 'Error',
      unknown: 'Desconocida',
      queued: 'En cola',
      running: 'En curso',
      pending: 'Pendiente',
      completed: 'Completada',
      failed: 'Fallida'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTENTE'
    },
    persistence: {
      installed: 'Instalada',
      notInstalled: 'No instalada'
    },
    quickPrompts: {
      help: 'Ayuda',
      privesc: 'Privesc',
      persistence: 'Persistencia',
      lateral: 'Movimiento lateral',
      pocAuto: 'PoC auto',
      aptModules: 'Módulos APT'
    },
    errors: {
      connectionError: 'Error de conexión al servidor',
      loadingError: 'Error al cargar las sesiones',
      actionError: 'Error al ejecutar la acción',
      serverError: 'Error interno del servidor',
      serviceUnavailable: 'Servicio temporalmente no disponible',
      loadFailed: 'Error de carga',
      screenshotFailed: 'Error al capturar pantalla',
      privescFailed: 'Error en la escalada de privilegios',
      persistenceFailed: 'Error al instalar la persistencia',
      aptExecutionFailed: 'Error al ejecutar el módulo APT'
    },
    actions: {
      screenshotSuccess: 'Captura de pantalla realizada',
      privescSuccess: 'Escalada de privilegios exitosa',
      privescCompleted: 'Intento de escalada finalizado',
      persistenceSuccess: 'Mecanismo de persistencia instalado',
      persistenceCompleted: 'Instalación completada'
    },
    privilegeLevel: 'Nivel de privilegio',
    lastActivity: 'Última actividad',
    screenshot: 'Captura de pantalla',
    privilegeEscalation: 'Escalada de privilegios',
    downloadLogs: 'Descargar logs',
    migrationRecommended: 'Migración recomendada',
    connected: 'Conectado',
    connecting: 'Conectando...',
    confirmInstallPersistence: '¿Instalar un mecanismo de persistencia?',
    confirmCloseSession: '¿Está seguro de que desea cerrar esta sesión?'
  },

  // Attack
  attack: {
    title: 'Centro de Ataque',
    description: 'Herramientas de ataque avanzadas y orquestador dinámico',
    selectTarget: 'Seleccionar objetivo',
    selectTechnique: 'Seleccionar técnica',
    launchAttack: 'Lanzar ataque',
    attackInProgress: 'Ataque en progreso',
    attackCompleted: 'Ataque completado',
    attackFailed: 'Ataque fallido',
    techniques: 'Técnicas',
    payloads: 'Cargas útiles',
    results: 'Resultados',
    dynamicOrchestrator: 'Orquestador Dinámico',
    attackGraph: 'Grafo de Ataque',
    attackBuilder: 'Constructor de Ataque',
    launchChain: 'Lanzar la cadena',
    continueChain: 'Reanudar',
    restartAll: 'Relanzar todo',
    executing: 'Ejecutando...',
    aiSuggestions: 'Sugerencias IA',
    ready: 'Listo',
    inProgress: 'En curso...'
  },
  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Herramientas de ataque AD con asistencia IA LLM y PoC automatizado',
    domain: 'Dominio',
    dcIp: 'IP del Controlador de Dominio',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    ntlmHash: 'Hash NTLM (opcional)',
    dcConfiguration: 'Configuración del Controlador de Dominio',
    attacks: 'Ataques AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Buscar un ataque, una herramienta...',
    allCategories: 'Todas las categorías',
    attackCategories: 'Categorías de Ataques',
    targetResults: 'Objetivo / Resultados',
    noDataMessage: 'Seleccione un ataque para comenzar',
    noDataHint: 'O use Auto PoC para una cadena de ataques',
    readyToStart: 'Listo para comenzar',
    stats: {
      attacks: 'Ataques',
      successful: 'Exitosos',
      failed: 'Fallidos',
      credentials: 'Credenciales',
      users: 'Usuarios',
      paths: 'Rutas',
    },
    attackWizard: 'Asistente de Ataques AD',
    backToAD: 'Volver a la página AD',
    auditRunning: 'Auditoría AD en curso',
    auditRunningDesc: 'Analizando Active Directory {domain}... La página se actualiza automáticamente.',
    auditFailed: 'Auditoría fallida',
    globalRiskScore: 'Puntuación de riesgo global',
    scoresByCategory: 'Puntuaciones por categoría',
    noScoresCalculated: 'Ninguna puntuación calculada',
    auditInfo: 'Información de la auditoría',
    criticalIndicatorsPriority: 'Indicadores críticos a tratar con prioridad',
    riskScoreCritical: 'El dominio presenta vulnerabilidades críticas que requieren acción inmediata.',
    riskScoreHigh: 'Se han identificado riesgos significativos en el dominio Active Directory.',
    riskScoreMedium: 'Algunos aspectos a mejorar con prioridad media.',
    riskScoreLow: 'El dominio presenta un nivel de riesgo bajo. Mantenga las buenas prácticas.',
    objectsAffected: '{count} objeto(s) afectado(s)',
    recommendedSolution: 'Solución recomendada',
    noActionRequired: 'Ninguna acción requerida',
    noRiskIndicators: 'El dominio no presenta ningún indicador de riesgo.',
    immediateActions: 'Acciones inmediatas',
    recommendedImprovements: 'Mejoras recomendadas',
    prioritizedActionPlan: 'Plan de acción priorizado basado en {count} indicadores detectados. Las acciones inmediatas (< 30d) deben tratarse antes de la generación de informes AD.',
    generateAIAnalysis: 'Generar el análisis IA',
    generateAIAnalysisDesc: 'La IA analizará los {count} indicadores AD para:',
    generatingAI: 'Análisis en curso…',
    generatingAIDesc: 'La IA analiza los {count} indicador(es) AD y genera la guía de ataque',
    generatingAITime: 'Esto puede tardar 2 a 4 minutos según la carga del servidor GPU',
    analysisGenerated: 'Análisis generado — {domain} · Puntuación {score}/100 ({risk})',
    indicatorsAnalyzed: '{count} indicador(es) analizado(s)',
    regenerate: 'Regenerar',
    rawResponse: 'Respuesta bruta',
    analysisError: 'Nota: El análisis utilizó un fallback (servicio IA no disponible).',
    downloadEvidenceReport: 'Descargar el informe de pruebas (.txt)',
    noIndicatorsForFilter: 'Ningún indicador de severidad {filter}.',
    noRiskIndicatorsDetected: 'Ningún indicador de riesgo detectado.',
    statsDomainAdmins: 'Admins de dominio',
    statsMaxPrivAccounts: 'Cuentas con máximo privilegio',
    statsKerberoastable: 'Kerberoastable',
    statsInventory: 'Inventario',
    statsPrivilegedGroups: 'Grupos con privilegios',
    statsKerberosDeleg: 'Kerberos y Delegación',
    statsOtherAnomalies: 'Otras anomalías',
    statsInterpretation: 'Interpretación de estadísticas',
    lapsDeployed: 'Desplegado',
    lapsAbsent: 'Ausente',
    highIndicators: 'Indicadores High',
    statusDone: '✓ Completado',
    statusRunning: '⟳ En curso',
    statusFailed: '✗ Fallido',
    scanIdLabel: 'ID del escaneo',
    startedLabel: 'Iniciado',
    completedLabel: 'Completado',
    sessionStatusCompleted: 'Completado',
    sessionStatusFailed: 'Fallido',
    sessionStatusStopped: 'Detenido',
    sessionStatusInitialized: 'Inicializado',
    sessionTabOverview: 'Vista general',
    sessionTabSteps: 'Pasos',
    sessionTabFindings: 'Findings',
    sessionTabTimeline: 'Cronología',
    sessionTabAI: 'Análisis IA',
    sessionFindingsDetected: 'Findings detectados',
    sessionStepsExecuted: 'Pasos ejecutados',
    sessionStepsFailed: '{count} fallidos, {skipped} ignorados',
    sessionCredentialsFound: 'Credenciales encontradas',
    sessionCompromisedAccounts: 'Cuentas comprometidas',
    sessionUsersEnumerated: 'Usuarios enumerados',
    sessionDuration: 'Duración: {duration}',
    sessionDomainCompromised: 'Dominio comprometido',
    sessionDomainCompromisedDesc: 'Las técnicas ejecutadas han demostrado el compromiso del dominio Active Directory {domain}. Acción inmediata requerida.',
    sessionAttackPathsFound: 'Rutas de ataque identificadas',
    sessionAttackPathsDesc: 'Se han identificado vectores de escalada de privilegios o movimiento lateral en el dominio.',
    sessionCriticalHighFindings: 'Findings críticos / altos',
    sessionStepsCompleted: 'Completados',
    sessionStepsSkipped: 'Ignorados',
    sessionNoMatchingSteps: 'Ningún paso correspondiente',
    sessionNoFindingsDetected: 'Ningún finding detectado',
    sessionNoFindingsForFilter: 'Ningún finding en este nivel de severidad.',
    sessionNoTimelineEvents: 'Ningún evento de cronología',
    sessionStepsLabel: '{count} pasos',
    sessionStepFindings: 'Findings del paso',
    sessionRecommendedRemediation: 'Remediación recomendada',
    sessionAICompromiseGuide: 'Análisis IA — Guía de compromiso AD',
    sessionAIWillAnalyze: 'La IA analizará todos los findings y pasos de esta sesión para:',
    sessionAIExplainDiscoveries: 'Explicar los descubrimientos',
    sessionAIIdentifyPaths: 'Identificar las rutas de ataque',
    sessionAIStepByStep: 'Guía de compromiso AD paso a paso',
    sessionAIPriorityRecs: 'Recomendaciones de remediación prioritarias',
    sessionAILoading: 'Generación automática de la guía de compromiso AD',
    sessionAILoadingTime: 'Esto puede tardar 2-4 minutos — procesamiento en segundo plano',
    sessionAIAnalysisFor: 'Análisis generado para {domain}',
    sessionAIAnalysisMeta: '{steps} pasos · {findings} findings analizados',
    sessionAIAnalysisCredentials: '· {count} credenciales',
    sessionDownloadEvidence: 'Descargar todas las pruebas (.txt)',
    sessionOutputLabel: 'Output',
    sessionStepFindingsLabel: 'Step findings',
    sessionAIAnalysisGenerationTime: 'Generación via Ollama (sylink/sylink2:27b) — aproximadamente 2-4 minutos',
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Plataforma de',
    platformSubtitle: 'Pentest Autónomo',
    platformDescription: 'Análisis de seguridad impulsado por IA con explotación automatizada e informes detallados.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autónoma',
      description: 'Inteligencia artificial que simula un pentester experto',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Detección Avanzada',
      description: 'Identificación automática de vulnerabilidades críticas',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Pruebas Completas',
      description: 'Escaneos de red, web, API e infraestructura',
      highlight: '100+ Herramientas'
    },
    instantReports: {
      title: 'Informes Instantáneos',
      description: 'Generación automática de informes PDF profesionales',
      highlight: 'Exportar PDF'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilidad',
    vulnerabilities: 'Vulnerabilidades detectadas',
    monitoring: 'Monitoreo',
    scanTime: 'Tiempo promedio de escaneo'
  },

  // Footer
  footer: {
    title: 'Plataforma de Escáner de Seguridad',
    subtitle: 'Sistema Autónomo de Pruebas de Penetración',
    terms: 'Términos de Uso',
    sales: 'Términos de Venta',
    privacy: 'Política de Privacidad',
    legalNotice: 'Aviso Legal',
    contact: 'Contacto',
    version: 'Versión',
    licence: 'Licencia n°',
    termsShort: 'Condiciones de uso (CGU)',
    salesShort: 'Condiciones de venta (CGV)',
    poweredBy: 'Impulsado por SYLink IA'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Enriquecimiento & Inteligencia de Amenazas',
    subtitle: 'Análisis avanzado de dominios e IPs con VirusTotal, headers de seguridad, email y geolocalización',
    newScan: 'Nuevo escaneo',
    quickScan: 'Escaneo rápido',
    fullScan: 'Escaneo completo',
    viewDetails: 'Ver detalles',
    exportReport: 'Exportar informe',
    refresh: 'Actualizar',
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Headers de seguridad',
      security_headers: 'Headers de seguridad',
      email_security: 'Seguridad de email',
      geoip: 'Geolocalización IP',
      reverse_ip: 'Reverse IP',
      full: 'Escaneo completo'
    },
    status: {
      pending: 'Pendiente',
      running: 'En ejecución',
      completed: 'Completado',
      failed: 'Fallido',
      cancelled: 'Cancelado'
    },
    threatLevels: {
      safe: 'Seguro',
      low: 'Bajo',
      medium: 'Medio',
      high: 'Alto',
      critical: 'Crítico'
    },
    form: {
      targetDomain: 'Dominio objetivo',
      targetDomainPlaceholder: 'ej: example.com',
      targetIp: 'Dirección IP (opcional)',
      targetIpPlaceholder: 'ej: 192.168.1.1',
      scanType: 'Tipo de escaneo',
      workspace: 'Workspace (opcional)',
      startScan: 'Iniciar escaneo',
      credits: 'Créditos requeridos'
    },
    results: {
      title: 'Resultados',
      noResults: 'Sin resultados disponibles',
      loading: 'Cargando resultados...',
      riskScore: 'Puntuación de riesgo',
      threatLevel: 'Nivel de amenaza',
      scannedAt: 'Escaneado el',
      duration: 'Duración'
    },
    headers: {
      title: 'Análisis de headers de seguridad',
      score: 'Puntuación',
      grade: 'Calificación',
      present: 'Presentes',
      missing: 'Faltantes',
      recommendations: 'Recomendaciones',
      headerName: 'Header',
      value: 'Valor',
      status: 'Estado',
      issues: 'Problemas'
    },
    email: {
      title: 'Seguridad de email',
      mxRecords: 'Registros MX',
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      valid: 'Válido',
      invalid: 'Inválido',
      notFound: 'No encontrado',
      policy: 'Política',
      vulnerabilities: 'Vulnerabilidades detectadas',
      recommendations: 'Recomendaciones'
    },
    geoip: {
      title: 'Geolocalización IP',
      location: 'Ubicación',
      country: 'País',
      region: 'Región',
      city: 'Ciudad',
      timezone: 'Zona horaria',
      isp: 'ISP',
      organization: 'Organización',
      isProxy: 'Proxy detectado',
      isVpn: 'VPN detectado',
      isTor: 'Tor detectado'
    },
    virustotal: {
      title: 'Análisis VirusTotal',
      reputation: 'Reputación',
      malicious: 'Malicioso',
      suspicious: 'Sospechoso',
      harmless: 'Inofensivo',
      undetected: 'No detectado'
    },
    errors: {
      scanFailed: 'El escaneo falló',
      insufficientCredits: 'Créditos insuficientes',
      invalidDomain: 'Dominio inválido',
      networkError: 'Error de red',
      invalidIp: 'Dirección IP inválida',
      timeout: 'Tiempo de espera agotado',
      unknownError: 'Error desconocido',
    },
    description: 'Analice objetivos con múltiples fuentes de inteligencia de seguridad',
    target: 'Objetivo',
    type: 'Tipo',
    modules: 'Módulos',
    quickScans: 'Escaneos rápidos',
    threatSummary: 'Resumen de amenazas',
    recentScans: 'Escaneos recientes',
    riskScore: 'Puntuación de riesgo',
    date: 'Fecha',
    noScans: 'Sin escaneos por el momento',
    scan: 'Analizar',
    quickResult: 'Resultado del escaneo rápido',
    scanDetails: 'Detalles del escaneo',
    statusLabel: 'Estado',
    scanTypes: {
      domain: 'Dominio',
      ip: 'Dirección IP',
      url: 'URL',
      ai_scan: 'Escaneo IA',
      network_discovery: 'Descubrimiento de red',
      vulnerability_scan: 'Escaneo de vulnerabilidades',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      expert: 'Escaneo experto',
      api_pentest: 'Pentest API',
      iot_scan: 'Escaneo IoT',
      ot_scan: 'Escaneo OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Escaneo Active Directory',
      ad_recon: 'Reconocimiento AD',
      ad_full: 'Escaneo AD completo',
      ldap_scan: 'Escaneo LDAP',
      kerberos_scan: 'Escaneo Kerberos',
      web_scan: 'Escaneo Web',
      web: 'Escaneo Web',
      quick: 'Rápido',
      quick_scan: 'Escaneo rápido',
      discovery: 'Descubrimiento',
      enumeration: 'Enumeración',
      vulnerability: 'Vulnerabilidades',
      exploitation: 'Explotación',
      passive: 'Pasivo',
      aggressive: 'Agresivo',
      credentials: 'Credenciales',
      recon: 'Reconocimiento',
      exploit: 'Explotación',
      bypass: 'Bypass',
      nmap: 'Escaneo Nmap',
      nikto: 'Escaneo Nikto',
      internal: 'Escaneo interno',
      external: 'Escaneo externo',
      network: 'Escaneo de red',
    },
    status: {
      queued: 'En cola',
    },
    email: {
      mechanisms: 'Mecanismos',
      selectors: 'Selectores',
    },
    geoip: {
      coordinates: 'Coordenadas',
      network: 'Información de red',
      asn: 'ASN',
      flags: 'Indicadores de seguridad',
      isDatacenter: 'Datacenter',
      isHosting: 'Alojamiento',
    },
    reverseIp: {
      title: 'Búsqueda Reverse IP',
      totalDomains: 'Dominios encontrados',
      domains: 'Lista de dominios',
      sharedHosting: 'Alojamiento compartido',
      hostingProvider: 'Proveedor de alojamiento',
      suspiciousDomains: 'Dominios sospechosos',
      riskScore: 'Puntuación de riesgo',
    },
    virustotal: {
      categories: 'Categorías',
      lastAnalysis: 'Último análisis',
      permalink: 'Enlace VirusTotal',
    },
    headers: {
      gradeDescriptions: {
        A: 'Excelente - Seguridad óptima',
        B: 'Bueno - Algunas mejoras posibles',
        C: 'Medio - Mejoras recomendadas',
        D: 'Bajo - Mejoras importantes necesarias',
        F: 'Insuficiente - Seguridad crítica a mejorar',
      },
    },
    stats: {
      totalScans: 'Total de escaneos',
      completedScans: 'Escaneos completados',
      pendingScans: 'Escaneos pendientes',
      failedScans: 'Escaneos fallidos',
      averageScore: 'Puntuación media',
      criticalThreats: 'Amenazas críticas',
      highThreats: 'Amenazas altas',
      creditsUsed: 'Créditos usados',
    },
    error: {
      targetRequired: 'El objetivo es obligatorio',
      scanFailed: 'Error al iniciar el escaneo',
      quickScanFailed: 'Error en el escaneo rápido',
      loadFailed: 'Error al cargar los detalles del escaneo',
      deleteFailed: 'Error al eliminar el escaneo',
    },
    success: {
      scanStarted: 'Escaneo iniciado con éxito',
      quickScanComplete: 'Escaneo rápido completado',
      scanDeleted: 'Escaneo eliminado',
    },
    tooltips: {
      virusTotalCredit: 'Usa la API de VirusTotal para analizar la reputación',
      headersCredit: 'Analiza las cabeceras HTTP de seguridad',
      emailCredit: 'Verifica SPF, DKIM y DMARC',
      geoipCredit: 'Geolocaliza la dirección IP',
      reverseIpCredit: 'Encuentra los dominios alojados en la misma IP',
      fullCredit: 'Realiza todos los análisis',
    },
    recentIndicators: 'Indicadores recientes',
    aiAnalysis: {
      title: 'Análisis IA',
      executiveSummary: 'Resumen ejecutivo',
      keyFindings: 'Puntos clave',
      recommendations: 'Recomendaciones',
    },
  },

  // Support
  support: {
    title: 'Soporte',
    myTickets: 'Mis Tickets de Soporte',
    manageRequests: 'Gestione sus solicitudes de asistencia',
    newTicket: 'Nuevo ticket',
    ticketDetails: 'Detalles del ticket',
    subject: 'Asunto',
    message: 'Mensaje',
    priority: 'Prioridad',
    status: 'Estado',
    category: 'Categoría',
    created: 'Creado',
    createdOn: 'Creado el',
    updated: 'Última actualización',
    resolved: 'Resuelto',
    resolvedOn: 'Resuelto el',
    noTickets: 'Sin tickets',
    noTicketsFound: 'No se encontraron tickets',
    noTicketsYet: 'Aún no ha creado ningún ticket de soporte',
    tryModifyingSearch: 'Intente modificar sus criterios de búsqueda',
    createFirstTicket: 'Crear mi primer ticket',
    sendMessage: 'Enviar mensaje',
    send: 'Enviar',
    sending: 'Enviando...',
    closeTicket: 'Cerrar ticket',
    closing: 'Cerrando...',
    ticketClosed: 'Este ticket está cerrado. Para una nueva solicitud, cree un nuevo ticket.',
    search: 'Buscar un ticket...',
    allStatuses: 'Todos los estados',
    refresh: 'Actualizar',
    backToTickets: 'Volver a los tickets',
    ticketNumber: 'Número',
    you: 'Usted',
    supportTeam: 'Soporte SYLink',
    system: 'Sistema',
    writeReply: 'Escriba su respuesta...',
    detailedDescription: 'Descripción detallada',
    informations: 'Información',
    needHelp: '¿Necesita ayuda?',
    responseTime: 'Tiempo de respuesta estimado',
    responseTimeDesc: 'Nuestro equipo generalmente responde dentro de las 24 horas hábiles. Los tickets urgentes se tratan con prioridad.',
    supportResponseDesc: 'Nuestro equipo de soporte generalmente responde dentro de las 24 horas hábiles.',
    newTicketTitle: 'Nuevo Ticket',
    newTicketDesc: 'Describa su problema y nuestro equipo le responderá rápidamente',
    describeIssue: 'Describa brevemente su problema...',
    relatedWorkspace: 'Cliente / Workspace relacionado (opcional)',
    noSpecificWorkspace: 'Ningún workspace específico',
    detailedDescPlaceholder: 'Describa su problema en detalle...',
    charactersCount: '{count} caracteres',
    charactersMin: '{count} caracteres (mínimo {min})',
    cancel: 'Cancelar',
    createTicket: 'Crear ticket',
    creating: 'Creando...',
    rateSupport: '¿Cómo califica la calidad de nuestro soporte?',
    comment: 'Comentario (opcional)...',
    confirm: 'Confirmar',
    messages: 'mensaje',
    messagesPlural: 'mensajes',
    resolutionNotes: 'Notas de resolución',
    yourRating: 'Su calificación',
    statuses: {
      open: 'Abierto',
      in_progress: 'En curso',
      waiting_customer: 'Esperando su respuesta',
      waiting_internal: 'En tratamiento',
      resolved: 'Resuelto',
      closed: 'Cerrado'
    },
    priorities: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
      lowDesc: 'No urgente, puede esperar',
      mediumDesc: 'Importancia normal',
      highDesc: 'Requiere atención rápida',
      urgentDesc: 'Impacto crítico en la actividad',
      priority: 'Prioridad'
    },
    categories: {
      technical: 'Técnico',
      billing: 'Facturación',
      feature_request: 'Solicitud de función',
      bug_report: 'Informe de error',
      account: 'Cuenta',
      security: 'Seguridad',
      other: 'Otro',
      technicalDesc: 'Problemas técnicos, errores, mal funcionamiento',
      billingDesc: 'Preguntas sobre facturas, pagos, suscripciones',
      feature_requestDesc: 'Sugerencias de mejora o nuevas funciones',
      bug_reportDesc: 'Informar de un error o comportamiento inesperado',
      accountDesc: 'Gestión de cuenta, acceso, permisos',
      securityDesc: 'Preguntas o preocupaciones de seguridad',
      otherDesc: 'Otro tipo de solicitud'
    },
    errors: {
      loadingTickets: 'Error al cargar los tickets',
      loadingTicket: 'Error al cargar el ticket',
      sendingMessage: 'Error al enviar el mensaje',
      closingTicket: 'Error al cerrar el ticket',
      creatingTicket: 'Error al crear el ticket',
      ticketNotFound: 'Ticket no encontrado',
      retry: 'Reintentar',
      fixFormErrors: 'Por favor corrija los errores en el formulario',
      subjectRequired: 'El asunto es requerido',
      subjectMinLength: 'El asunto debe tener al menos 5 caracteres',
      descriptionRequired: 'La descripción es requerida',
      descriptionMinLength: 'La descripción debe tener al menos 20 caracteres'
    },
    success: {
      ticketCreated: 'Ticket {number} creado con éxito',
      messageSent: 'Mensaje enviado',
      ticketClosed: 'Ticket cerrado con éxito'
    }
  },

  // Pricing
  pricing: {
    title: 'Elija su plan',
    subtitle: 'Soluciones de seguridad adaptadas a todos los tamaños de empresa.',
    monthly: 'Mensual',
    yearly: 'Anual',
    yearlyDiscount: '-17%',
    perMonth: 'mes',
    perYear: 'año',
    ht: 'Sin IVA',
    or: 'O sea',
    perMonthShort: '/mes',
    onQuote: 'Bajo presupuesto',
    free: 'Gratis',
    plans: {
      gratuit: {
        name: 'Gratis',
        subtitle: 'Descubrimiento',
        description: 'Ideal para probar la plataforma',
        cta: 'Comenzar gratis'
      },
      pro: {
        name: 'Pro',
        subtitle: 'El más popular',
        description: 'Para profesionales y PYMES',
        cta: 'Elegir Pro',
        badge: 'Recomendado'
      },
      entreprise: {
        name: 'Empresa',
        subtitle: 'Para grandes equipos',
        description: 'Funciones avanzadas y soporte dedicado',
        cta: 'Elegir Empresa'
      },
      entreprise_plus: {
        name: 'Grupo',
        subtitle: 'Para grandes organizaciones',
        description: 'Volumen extendido y soporte premium',
        cta: 'Elegir Grupo'
      },
      sur_mesure: {
        name: 'A medida',
        subtitle: 'Solución personalizada',
        description: 'Adaptada a sus necesidades específicas',
        cta: 'Contáctenos'
      }
    },
    features: {
      simulationOnly: 'Solo modo simulación',
      oneUser: '1 usuario',
      oneTarget: '1 objetivo de prueba',
      basicDashboard: 'Dashboard básico',
      realScans: 'Escaneos reales',
      pdfReports: 'Informes PDF',
      technicalSupport: 'Soporte técnico',
      apiAccess: 'Acceso API',
      unlimitedScans: 'Escaneos IA ilimitados',
      fiveUsers: '5 usuarios',
      tenTargets: '10 objetivos',
      customPdfReports: 'Informes PDF personalizados',
      credentialSearch: 'Búsqueda de credenciales',
      autoScheduling: 'Programación automática',
      prioritySupport: 'Soporte prioritario',
      allProFeatures: 'Todo el plan Pro +',
      fifteenUsers: '15 usuarios',
      thirtyTargets: '30 objetivos',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Auditoría de cumplimiento',
      slaGuarantee: 'SLA garantizado 99.9%',
      dedicatedSupport: 'Soporte dedicado',
      teamTraining: 'Formación del equipo incluida',
      allEnterpriseFeatures: 'Todo el plan Empresa +',
      unlimitedUsers: 'Usuarios ilimitados',
      fiftyTargets: '50 objetivos',
      advancedWorkspaces: 'Multi-workspaces avanzados',
      whiteLabelReports: 'Informes white-label',
      support24_7: 'Soporte dedicado 24/7',
      accountManager: 'Account manager dedicado',
      customOnboarding: 'Onboarding personalizado',
      allGroupeFeatures: 'Todo el plan Grupo +',
    allEnterprisePlusFeatures: 'Todo el plan Grupo +',
      dedicatedInfra: 'Infraestructura dedicada',
      customIntegrations: 'Integraciones personalizadas',
      specificDevelopment: 'Desarrollos específicos',
      sourceCodeAudit: 'Auditoría de código fuente',
      manualPentest: 'Pruebas de intrusión manuales',
      cissoSupport: 'Acompañamiento CISO',
      customContract: 'Contrato a medida'
    },
    whyChoose: '¿Por qué elegir SYLink Pentest?',
    aiTitle: 'Inteligencia Artificial',
    aiDesc: 'Nuestra IA analiza y explota las vulnerabilidades de forma autónoma.',
    securityTitle: 'Seguridad Máxima',
    securityDesc: 'Sus datos están cifrados y seguros.',
    reportsTitle: 'Informes Detallados',
    reportsDesc: 'Genere informes PDF profesionales con recomendaciones.',
    faqTitle: 'Preguntas frecuentes',
    faqCanChangePlan: '¿Puedo cambiar de plan?',
    faqCanChangePlanAnswer: 'Sí, puede actualizar o degradar su plan en cualquier momento.',
    faqFreePlan: '¿Cómo funciona el plan gratuito?',
    faqFreePlanAnswer: 'El plan gratuito le permite probar la plataforma en modo simulación.',
    faqCommitment: '¿Hay algún compromiso?',
    faqCommitmentAnswer: 'No, sin compromiso. Puede cancelar en cualquier momento.',
    faqSupport: '¿Qué soporte está incluido?',
    faqSupportAnswer: 'El plan Pro incluye soporte prioritario por correo electrónico.',
    needHelpChoosing: '¿Necesita ayuda para elegir?',
    needHelpDesc: 'Nuestro equipo está disponible para asesorarle.',
    contactUs: 'Contáctenos',
    requestCall: 'Solicitar una llamada',
    welcomeTitle: '¡Bienvenido a SYLink Pentest!',
    welcomeDesc: 'Su cuenta está activada. Elija el plan que corresponda a sus necesidades.',
    paymentError: 'Error de pago',
    close: 'Cerrar',
    redirecting: 'Redirigiendo...',
    securedByStripe: 'Pago seguro por Stripe',
    needHelpDescShort: 'Nuestro equipo está disponible para acompañarle y responder todas sus preguntas.',
    welcomeDescShort: 'Elija el plan que corresponda a sus necesidades',
    detailedComparison: 'Comparación detallada',
    infrastructureOptions: 'Opciones de infraestructura',
    infrastructureDesc: 'Elija el modo de despliegue adaptado a sus necesidades y limitaciones',
    choosePlan: 'Elija su',
    choosePlanHighlight: 'plan',
    pageSubtitle: 'Automatice sus pruebas de intrusión con IA. Del freelance a la empresa, tenemos el plan que necesita.',
    contactBanner: 'Todos nuestros planes están personalizados a sus necesidades',
    foreverFree: 'Para siempre',
    customPricing: 'Bajo presupuesto',
    customPricingLabel: 'Precio personalizado',
    perMonthHT: '/mes sin IVA',
    billedPerYear: 'Facturado',
    billedPerYearSuffix: '/año',
    requestQuote: 'Solicitar presupuesto',
    startFree: 'Comenzar gratis',
    learnMoreDedicated: 'Saber más sobre los servidores dedicados',
    readOnlyApi: 'Solo lectura',
    featureRow: 'Función',
    priceRow: 'Precio'
  },

  // Notifications
  notifications: {
    managementCenter: 'Centro de gestión de alertas y eventos',
    aiAssistant: 'Asistente IA',
    aiAssistantTitle: 'Asistente IA - Notificaciones',
    aiPlaceholder: 'Haga una pregunta sobre sus notificaciones...',
    settings: 'Configuración de notificaciones',
    soundEnabled: 'Sonidos activados',
    criticalOnly: 'Solo críticas',
    autoMarkRead: 'Marcar como leído automáticamente',
    filters: 'Filtros',
    total: 'Total',
    unread: 'No leídas',
    critical: 'Críticas',
    warning: 'Advertencia',
    success: 'Éxito',
    info: 'Info',
    markAllRead: 'Marcar todo como leído',
    clearAll: 'Borrar todo',
    noNotifications: 'Sin notificaciones',
    noNotificationsDesc: 'No tiene ninguna notificación por el momento',
    allRead: 'Todas sus notificaciones están leídas',
    noNotificationsType: 'Sin notificaciones de tipo "{type}"',
    typeCritical: 'Crítica',
    typeWarning: 'Advertencia',
    typeSuccess: 'Éxito',
    typeInfo: 'Info',
    criticalVulnsFound: '{count} vulnerabilidad(es) crítica(s)',
    vulnsDetected: '{count} vulnerabilidad(es) detectada(s)',
    hostsScanned: '{count} hosts escaneados en {target}',
    scanCompletedNoVulns: 'Escaneo completado - Sin vulnerabilidades',
    noVulnsDetected: 'Ninguna vulnerabilidad detectada en {target}',
    scanInProgress: 'Escaneo en curso',
    analyzing: 'Analizando {target}...',
    scanFailed: 'Escaneo fallido',
    errorOn: 'Error en {target}',
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {count}min',
    hoursAgo: 'hace {count}h',
    daysAgo: 'hace {count}d',
    scanRunning: 'Escaneo en curso',
    viewAll: 'Ver todas las notificaciones',
    scanCompleted: 'Escaneo completado'
  },

  // Antivirus (ClamAV)
  antivirus: {
    status: 'Estado',
    title: 'Escáner Antivirus',
    subtitle: 'Analizar archivos contra malware con ClamAV',
    adminTitle: 'Gestión Antivirus',
    adminSubtitle: 'Monitorear ClamAV y gestionar cuarentena',
    scannerTab: 'Escáner de Archivos',
    adminTab: 'Administración',

    // File Upload
    dropzone: 'Arrastra un archivo aquí o haz clic para subir',
    dropzoneActive: 'Suelta el archivo aquí...',
    scanning: 'Escaneando...',
    uploadAndScan: 'Subir y Escanear',
    maxFileSize: 'Tamaño máximo de archivo: {size}',

    // Scan Results
    scanResult: 'Resultado del escaneo',
    clean: 'Limpio',
    infected: 'Infectado',
    error: 'Error',
    pending: 'Pendiente',
    threatDetected: 'Amenaza detectada',
    noThreatsFound: 'No se encontraron amenazas',
    threatName: 'Nombre de la amenaza',
    scanTime: 'Tiempo de escaneo',
    fileHash: 'Hash del archivo',

    // History
    scanHistory: 'Historial de escaneos',
    noScansYet: 'Sin escaneos todavía',
    noScansYetDesc: 'Sube un archivo para comenzar a escanear',

    // Admin Dashboard
    clamavStatus: 'Estado de ClamAV',
    version: 'Versión',
    signatureCount: 'Número de firmas',
    lastUpdate: 'Última actualización',
    databaseStatus: 'Estado de la base de datos',
    upToDate: 'Actualizado',
    outdated: 'Desactualizado',

    // Statistics
    statistics: 'Estadísticas',
    totalScans: 'Total de escaneos',
    cleanFiles: 'Archivos limpios',
    infectedFiles: 'Archivos infectados',
    errorScans: 'Escaneos con error',

    // Quarantine
    quarantine: 'Cuarentena',
    quarantineEmpty: 'Cuarentena vacía',
    quarantineEmptyDesc: 'No hay archivos en cuarentena',
    deleteFromQuarantine: 'Eliminar de cuarentena',
    cleanupQuarantine: 'Limpiar cuarentena',

    // Errors
    uploadError: 'Error al subir el archivo',
    scanError: 'Error al escanear el archivo',
    fileTooLarge: 'El archivo es demasiado grande',
    invalidFileType: 'Tipo de archivo no válido',
    serviceUnavailable: 'Servicio antivirus no disponible',
    scanFile: 'Escanear un archivo',
    scanNow: 'Escanear ahora',
    scanAll: 'Escanear todos los archivos',
    dropOrClick: 'Soltar un archivo o hacer clic para seleccionar',
    dropFiles: 'Soltar archivos aquí o hacer clic para seleccionar',
    maxSize: 'Tamaño máximo por archivo',
    selectedFiles: 'Archivos seleccionados',
    recentScans: 'Análisis recientes',
    summary: 'Resumen del análisis',
    unavailable: 'ClamAV no disponible',
    dataScanned: 'Datos analizados',
    threatsBySeverity: 'Amenazas por severidad',
    performance: 'Rendimiento',
    avgScanTime: 'Tiempo promedio de análisis',
    cacheEntries: 'Entradas en caché',
    filename: 'Nombre del archivo',
    size: 'Tamaño',
    threat: 'Amenaza',
    severity: 'Severidad',
    scannedAt: 'Analizado',
    daemonStatus: 'Estado del demonio',
    signatureVersion: 'Versión de firmas',
    reloadSignatures: 'Recargar firmas',
    noQuarantine: 'Ningún archivo en cuarentena',
    quarantinedAt: 'En cuarentena desde',
    expiresAt: 'Expira',
    cleanupExpired: 'Limpiar expirados',
    confirmDelete: '¿Está seguro de que desea eliminar definitivamente este archivo?',
    typeNotAllowed: 'Tipo de archivo no permitido',
    total: 'Total'
  },

  // Contracts
  contracts: {
    title: 'Contratos',
    contract: 'Contrato',
    newContract: 'Nuevo contrato',
    createContract: 'Crear contrato',
    editContract: 'Editar contrato',
    contractNumber: 'Referencia del contrato',
    contractTitle: 'Título',
    draft: 'Borrador',
    pendingSignature: 'Pendiente de firma',
    signed: 'Firmado',
    active: 'Activo',
    completed: 'Completado',
    expired: 'Expirado',
    cancelled: 'Cancelado',

    // Status
    status: {
      draft: 'Borrador',
      pending_signature: 'Pendiente de firma',
      signed: 'Firmado',
      active: 'Activo',
      completed: 'Completado',
      expired: 'Expirado',
      cancelled: 'Cancelado'
    },

    // Provider
    provider: 'Proveedor',
    providerInfo: 'Información del proveedor',
    providerName: 'Nombre de la empresa',
    providerSiret: 'SIRET',
    providerAddress: 'Dirección',

    // Client
    client: 'Cliente',
    clientInfo: 'Información del cliente',
    clientName: 'Nombre de la empresa',
    clientRepresentative: 'Representante del cliente',
    clientContact: 'Contacto',

    // Perimeter
    perimeter: 'Perímetro',
    perimeterDescription: 'Rangos de IP y objetivos a probar',
    addPerimeterItem: 'Añadir elemento al perímetro',

    // Period
    interventionPeriod: 'Período de intervención',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    riskPeriod: 'Período de riesgo (días)',

    // Signature
    signature: {
      title: 'Firma electrónica',
      sign: 'Firmar',
      signed: 'Firmado',
      pendingSignature: 'Pendiente de firma',
      signContract: 'Firmar contrato',
      signatureType: 'Tipo de firma',
      typed: 'Escrita',
      drawn: 'Dibujada',
      uploaded: 'Subida',

      // Signatory
      signatory: 'Firmante',
      signatoryInfo: 'Identidad del firmante',
      signatoryFirstName: 'Nombre',
      signatoryLastName: 'Apellido',
      signatoryEmail: 'Correo electrónico',
      signatoryFullName: 'Nombre completo',

      // Legal
      legalMention: 'Mención legal',
      legalAcceptance: 'Acepto los términos del contrato',
      acceptTerms: 'Confirmo haber leído y aceptado este contrato de pentest',

      // Verification
      verification: 'Verificación',
      verificationMethod: 'Método de verificación',
      smsVerification: 'Verificación por SMS',
      smsCode: 'Código SMS',
      sendCode: 'Enviar código',
      verifyCode: 'Verificar código',
      codeExpired: 'Código expirado',
      invalidCode: 'Código inválido',
      codeSent: 'Código enviado a su teléfono',

      // Metadata (DocuSign-style)
      metadata: 'Metadatos de la firma',
      signedBy: 'Firmado por',
      signedAt: 'Firmado el',
      signedAtTime: 'Hora de la firma',
      ipAddress: 'Dirección IP',
      userAgent: 'Navegador / Dispositivo',
      geolocation: 'Ubicación',

      // Certificate
      certificate: 'Certificado de firma',
      certificateOfCompletion: 'Certificado de finalización',
      signatureCertificate: 'Certificado de firma',
      downloadCertificate: 'Descargar certificado',
      viewCertificate: 'Ver certificado',

      // Integrity
      integrity: 'Integridad del documento',
      documentHash: 'Hash del documento (SHA-512)',
      signatureHash: 'Hash de la firma (SHA-512)',
      hashVerified: 'Hash verificado',
      hashMismatch: 'Error de hash',

      // Timeline / Audit
      timeline: 'Cronología',
      auditTrail: 'Registro de auditoría',
      eventLog: 'Registro de eventos',
      created: 'Creado',
      sent: 'Enviado',
      viewed: 'Visto',
      signatureStarted: 'Firma iniciada',
      signatureCompleted: 'Firma completada',

      // Success
      success: '¡Contrato firmado con éxito!',
      successMessage: 'El contrato ha sido firmado y ahora está activo.',
      thankYou: 'Gracias por su firma',

      // Errors
      error: 'Error de firma',
      errorMessage: 'No se pudo firmar el contrato',
      expired: 'Enlace de firma expirado',
      alreadySigned: 'Contrato ya firmado',
      invalidToken: 'Enlace de firma inválido',
      signatoryName: 'Nombre del firmante',
      signatureDate: 'Fecha y hora de la firma',
      acceptPentest: 'Válido para aceptación de Pentest',
      smsVerified: 'Validado',
      smsPending: 'Pendiente',
      hashAlgorithm: 'Algoritmo',
      sha512: 'SHA-512',
      createdAt: 'Creado el',
      sentAt: 'Enviado el',
      viewedAt: 'Consultado el',
      signedAt: 'Firmado el',
      viewCount: 'Número de consultas',
      action: 'Acción',
      timestamp: 'Marca de tiempo',
      smsRequested: 'Código SMS solicitado',
      smsVerifiedAction: 'Código SMS verificado',
      signedAction: 'Firma realizada',
      downloaded: 'Descarga',
      certificateType: 'CERTIFICADO DE FIRMA',
      platform: 'Plataforma',
      eidas: 'Firma electrónica conforme al reglamento eIDAS (UE) 910/2014',
      generatedAt: 'Certificado generado el',
      downloadProof: 'Descargar la prueba de firma',
      resendEmail: 'Reenviar por correo',
      contractSigned: '¡Contrato firmado con éxito!',
      copySentByEmail: 'Se enviará una copia de este certificado por correo electrónico.',
      enterSmsCode: 'Ingrese el código SMS',
      smsCodeSent: 'Código SMS enviado',
      tooManyAttempts: 'Demasiados intentos'
    },

    // Actions
    send: 'Enviar para firma',
    resend: 'Reenviar',
    cancel: 'Cancelar contrato',
    download: 'Descargar PDF',
    downloadSigned: 'Descargar PDF firmado',
    preview: 'Vista previa',

    // Notifications
    sentSuccess: 'Contrato enviado para firma',
    signedSuccess: 'Contrato firmado con éxito',
    cancelledSuccess: 'Contrato cancelado'
  },

  // VPN Configuration
  vpn: {
    title: 'Configuración VPN',
    configurations: 'Configuraciones VPN',
    noConfigurations: 'Sin configuraciones VPN',
    uploadConfig: 'Subir configuración',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    disconnecting: 'Desconectando...',
    connect: 'Conectar',
    disconnect: 'Desconectar',
    server: 'Servidor',
    saveCredentials: 'Guardar credenciales para esta VPN',
    status: 'Estado VPN',
    protocol: 'Protocolo',
    interface: 'Interfaz',
    publicIp: 'IP Pública',
    vpnIp: 'IP VPN',
    country: 'País',
    city: 'Ciudad',
    connectedSince: 'Conectado desde',
    routes: {
      title: 'Rutas de Red',
      description: 'Gestionar rutas de red personalizadas para VPN',
      addRoute: 'Añadir ruta',
      destination: 'Destino CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Puerta de enlace',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Descripción',
      routeDescriptionPlaceholder: 'Red interna del cliente',
      noRoutes: 'Sin rutas configuradas',
      deleteRoute: 'Eliminar ruta',
      applyRoutes: 'Aplicar rutas',
      routeAdded: 'Ruta añadida correctamente',
      routeDeleted: 'Ruta eliminada',
      routesApplied: 'Rutas aplicadas',
      invalidCidr: 'Formato CIDR inválido',
      invalidGateway: 'Dirección IP inválida',
      active: 'Activa',
      inactive: 'Inactiva'
    },
    topology: {
      title: 'Topología de Red',
      server: 'Servidor Sylink',
      internet: 'Internet',
      vpnGateway: 'Gateway VPN',
      clientNetwork: 'Red del Cliente',
      online: 'En línea',
      offline: 'Fuera de línea',
      activeRoutes: 'Rutas activas',
      totalRoutes: 'Rutas totales',
      networkGateway: 'Puerta de enlace de red',
      subnetsCount: '{{count}} subredes'
    },
    messages: {
      configUploaded: 'Configuración VPN subida',
      configDeleted: 'Configuración VPN eliminada',
      connectionSuccess: 'VPN conectado correctamente',
      connectionFailed: 'Error de conexión VPN',
      disconnectionSuccess: 'VPN desconectado',
      disconnectionFailed: 'Error de desconexión VPN',
      saveError: 'Error al guardar',
      deleteError: 'Error al eliminar',
      connectError: 'Error de conexión VPN',
      disconnectError: 'Error de desconexión VPN'
    },
    loadingWorkspaces: 'Cargando workspaces...',
    noWorkspace: 'Sin workspace',
    noWorkspaceAvailable: 'Sin workspace disponible',
    noVpnFoundFor: 'Ninguna VPN encontrada para "{query}"',
    deleteStoredCredentialsTitle: 'Eliminar credenciales guardadas',
    saveCredentialsSecurely: 'Guardar las credenciales de forma segura',
    saveCredentialsNow: 'Guardar ahora',
    noVpnAvailable: 'Sin configuración VPN disponible',
    loadingConfigs: 'Cargando configuraciones VPN...'
  },

  // Severity levels (used across components)
  severity: {
    critical: 'Crítico',
    high: 'Alto',
    medium: 'Medio',
    low: 'Bajo',
    info: 'Info'
  },

  // APT Modules
  apt: {
    dangerousModule: 'Módulo peligroso - Usar con precaución',
    addToChain: 'Añadir a cadena',
    createChain: 'Crear cadena de ataque',
    createChainButton: 'Crear cadena',
    chainName: 'Nombre de la cadena',
    selectedModules: 'Módulos seleccionados',
    addModulesFromList: 'Añada módulos desde la lista de la derecha',
    availableModules: 'Módulos disponibles',
    newChain: 'Nueva cadena',
    executeModule: 'Ejecutar {name}',
    loadError: 'Error al cargar datos APT',
    requiredParams: 'Parámetros requeridos',
    executions: 'Ejecuciones',
    successful: 'exitosas',
    avgTime: 'Tiempo medio',
    modulesApt: 'Módulos APT',
    chains: 'Cadenas',
    evidence: 'Evidencias',
    mitreMatrix: 'Matriz MITRE ATT&CK',
    category: 'Categoría',
    criticality: 'Criticidad',
    mitreTactic: 'Táctica MITRE',
    allCategories: 'Todas',
    allCriticalities: 'Todas',
    allTactics: 'Todas',
    low: 'Bajo',
    medium: 'Medio',
    high: 'Alto',
    critical: 'Crítico',
    noModulesAvailable: 'No hay campañas APT disponibles por ahora',
    noModulesFiltered: 'Ningún módulo coincide con los filtros seleccionados',
    noChains: 'No se han creado cadenas de ataque. Crea una para comenzar.',
    noEvidence: 'No se ha recopilado evidencia. Ejecuta módulos para recopilar evidencias.',
    chainStatus: 'Estado',
    chainProgress: 'Progreso',
    chainModules: 'Módulos',
    chainCreatedAt: 'Creado el',
    executeChain: 'Ejecutar {name}',
    moduleLaunched: 'Módulo {name} lanzado',
    moduleLaunchError: 'Error al lanzar el módulo',
    chainCreated: 'Cadena creada con éxito',
    chainCreateError: 'Error al crear la cadena',
    chainLaunched: 'Cadena lanzada',
    chainLaunchError: 'Error al lanzar la cadena',
    chainPaused: 'Cadena pausada',
    chainCancelled: 'Cadena cancelada',
    dangerWarning: 'Este módulo está marcado como peligroso. Úselo con precaución.',
    modulesAvailable: 'módulos disponibles',
    target: 'Objetivo',
    duration: 'Duración',
    result: 'Resultado',
    title: 'Título',
    classification: 'Clasificación',
    size: 'Tamaño',
    validated: 'Validado',
    searchPlaceholder: 'Buscar...',
    tool: 'Herramienta',
    module: 'Módulo',
    exitCode: 'Código de salida',
    status: {
      pending: 'Pendiente',
      queued: 'En cola',
      running: 'En curso',
      paused: 'Pausado',
      completed: 'Completado',
      failed: 'Fallido',
      cancelled: 'Cancelado',
      draft: 'Borrador',
      ready: 'Listo'
    },
    categories: {
      reconnaissance: 'Reconocimiento',
      resource_development: 'Desarrollo de recursos',
      initial_access: 'Acceso inicial',
      execution: 'Ejecución',
      persistence: 'Persistencia',
      privilege_escalation: 'Escalada de privilegios',
      defense_evasion: 'Evasión de defensa',
      credential_access: 'Acceso a credenciales',
      discovery: 'Descubrimiento',
      lateral_movement: 'Movimiento lateral',
      collection: 'Recolección',
      command_and_control: 'Mando y control',
      exfiltration: 'Exfiltración',
      impact: 'Impacto'
    },
    criticalities: {
      low: 'Bajo',
      medium: 'Medio',
      high: 'Alto',
      critical: 'Crítico'
    }
  },

  // Equipment
  equipment: {
    title: 'Gestión de equipos',
    subtitle: 'Detecte, categorice y ataque los equipos de red',
    totalEquipment: 'Total de equipos',
    totalEquipmentDesc: 'Número total de equipos registrados en la base de datos.',
    equipmentLabel: 'equipos',
    totalAttacks: 'Total de ataques',
    attacksLabel: 'ataques',
    successfulAttacks: 'Ataques exitosos',
    successfulAttacksLabel: 'exitosos',
    ongoingAttacks: 'Ataques en curso',
    ongoingAttacksLabel: 'en curso',
    typesTab: 'Tipos de equipos',
    detectedTab: 'Equipos detectados',
    attacksTab: 'Ataques',
    autoDetect: 'Auto-Detectar',
    refresh: 'Actualizar',
    searchPlaceholder: 'Buscar…',
    category: 'Categoría',
    allCategories: 'Todas'
  },

  // Workspace selector
  workspace: {
    select: 'Seleccione un espacio de trabajo',
    selectTitle: 'Selección de espacio de trabajo',
    selectDescription: 'Elija un espacio de trabajo para continuar',
    searchPlaceholder: 'Buscar un espacio de trabajo...',
    noWorkspaces: 'No hay espacios de trabajo disponibles',
    noWorkspacesYet: 'No se han creado espacios de trabajo',
    noResults: 'No se encontró ningún espacio de trabajo',
    createFirst: 'Cree su primer espacio de trabajo',
    createNew: 'Crear un espacio de trabajo',
    manageAll: 'Gestionar espacios de trabajo',
    continue: 'Continuar',
    switchError: 'Error al cambiar el espacio de trabajo',
    switchSuccess: 'Espacio de trabajo cambiado con éxito',
    scan: 'escáner',
    scans: 'escáneres',
    createRequired: 'Espacio de trabajo requerido',
    createRequiredDescription: 'Debe crear un espacio de trabajo para acceder a esta sección.',
    selectRequired: 'Selección requerida',
    selectRequiredDescription: 'Seleccione un espacio de trabajo para acceder a esta sección. Tiene',
    workspaceAvailable: 'espacio de trabajo disponible.',
    workspacesAvailable: 'espacios de trabajo disponibles.',
    selectWorkspace: 'Seleccione un espacio de trabajo'
  },

  // Phishing Simulation
  phishing: {
    title: 'Simulación de Phishing',
    subtitle: 'Pruebe la concienciación de seguridad de los empleados con campañas de phishing simuladas',
    campaignsTab: 'Campañas',
    templatesTab: 'Plantillas',
    targetsTab: 'Grupos objetivo',
    analyticsTab: 'Estadísticas',
    settingsTab: 'Configuración',
    totalCampaigns: 'Total de campañas',
    emailsSent: 'Correos enviados',
    clickRate: 'Tasa de clics',
    reportRate: 'Tasa de reporte',
    recentCampaigns: 'Campañas recientes',
    newCampaign: 'Nueva campaña',
    campaignName: 'Nombre de la campaña',
    status: 'Estado',
    sent: 'Enviados',
    opened: 'Abiertos',
    clicked: 'Clicados',
    reported: 'Reportados',
    actions: 'Acciones',
    viewDetails: 'Ver detalles',
    emailTemplates: 'Plantillas de correo',
    createTemplate: 'Crear plantilla',
    targetGroups: 'Grupos objetivo',
    createGroup: 'Crear grupo',
    groupName: 'Nombre del grupo',
    members: 'Miembros',
    lastUsed: 'Último uso',
    edit: 'Editar',
    delete: 'Eliminar',
    analyticsOverview: 'Resumen de análisis',
    clickRateTrend: 'Tendencia de tasa de clics',
    reportRateTrend: 'Tendencia de tasa de reporte',
    chartPlaceholder: 'El gráfico se mostrará aquí',
    departmentComparison: 'Comparación por departamento',
    settings: 'Configuración de Phishing',
    smtpConfig: 'Configuración SMTP',
    smtpServer: 'Servidor SMTP',
    smtpPort: 'Puerto SMTP',
    trackingSettings: 'Configuración de seguimiento',
    trackOpens: 'Rastrear aperturas de correo',
    trackClicks: 'Rastrear clics en enlaces',
    trackSubmissions: 'Rastrear envíos de credenciales',
    saveSettings: 'Guardar configuración',
    reference: 'Referencia',
    statusCompleted: 'Completado',
    statusActive: 'Activa',
    statusScheduled: 'Programada',
    statusCancelled: 'Cancelada',
    statusDraft: 'Borrador',
    categoryCredentialHarvest: 'Recolección de credenciales',
    categoryLinkClick: 'Clic en enlace',
    categoryAttachment: 'Adjunto'
  },

  // Sankey Analysis
  sankey: {
    title: 'Diagrama de Flujo de Seguridad',
    clickForAiAnalysis: 'Haga clic en un elemento para el análisis IA',
    exploitable: 'Explotable',
    nonExploitable: 'No explotable',
    columns: {
      workspaces: 'Espacios de trabajo',
      targets: 'Objetivos',
      assets: 'Activos',
      vulnerabilities: 'Vulnerabilidades',
      exploitability: 'Explotabilidad',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Espacios de trabajo',
      targets: 'Objetivos',
      critical: 'Crítico',
      nonExploitable: 'No exploit.'
    },
    severity: {
      critical: 'Críticos',
      high: 'Altos',
      medium: 'Medios',
      low: 'Bajos'
    },
    analysis: {
      model: 'Modelo',
      changeModel: 'Analizar con otro LLM',
      selectModel: 'Seleccionar modelo LLM',
      regenerateWith: 'Regenerar análisis con otro modelo',
      recommended: 'Recomendado',
      regenerate: 'Regenerar análisis'
    },
    noScansAvailable: 'No hay escaneos disponibles para visualización',
    scansLabel: 'escaneos',
    hostsLabel: 'hosts',
    portsLabel: 'puertos',
    occurrences: 'ocurrencia(s)',
    tooltip: {
      element: 'Elemento',
      scansHostsVulns: '{scans} escaneos • {hosts} hosts • {vulns} vulnerabilidades',
      ipHostsVulns: '{ip} • {hosts} hosts • {vulns} vulnerabilidades',
      vulnsCount: '{count} vulnerabilidades',
      clickForAi: 'Haga clic para análisis IA'
    },
    stats: {
      workspaces: 'Espacios de trabajo',
      targets: 'Objetivos',
      assets: 'Activos',
      vulnerabilities: 'Vulnerabilidades',
      exploitable: 'Explotable'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'Orquestador LLM',
    subtitle: 'Gestión y supervisión de modelos con aceleración GPU',
    gpuStatus: 'Estado GPU',
    vram: 'VRAM',
    utilization: 'Utilización',
    load: 'Cargar',
    loaded: 'Cargado',
    noTarget: 'Sin objetivo',
    entries: 'entradas',
    vulnerabilities: 'vulnerabilidades',
    credentials: 'credenciales',
    poolStatus: 'Estado del Pool GPU',
    servers: 'servidores',
    moreModels: 'más',
    orchestratorMetrics: 'Métricas del Orquestador',
    totalRequests: 'Solicitudes totales',
    modelSwaps: 'Cambios de modelo',
    avgSwapTime: 'Tiempo medio de cambio',
    inferences: 'Inferencias',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    refresh: 'Actualizar',
    availableModels: 'Modelos disponibles',
    activeSessions: 'Sesiones activas',
    noActiveSessions: 'No hay sesiones activas',
    noSessionsHint: 'Las sesiones LLM utilizan inteligencia artificial para analizar vulnerabilidades automáticamente.',
    noSessionsAction: 'Iniciar una sesión',
    readyStatus: 'Listo para iniciar',
    howToStart: 'Inicie un escaneo para comenzar una sesión LLM',
    waitingForScan: 'Esperando un escaneo',
    quickActions: 'Acciones rápidas',
    newSession: 'Nueva sesión',
    requestCheckpoint: 'Solicitar un punto de control',
    hashcatTasks: 'Tareas Hashcat',
    loadStatusFailed: 'Error al cargar el estado LLM',
    loadingModel: 'Cargando {{model}}...',
    swapFailed: 'Error al cambiar de modelo',
    noModel: 'Ninguno',
    online: 'En línea',
    offline: 'Sin conexión',
    serviceUnavailable: 'Servicio LLM no disponible'
  },

  // Tool Categories
  toolCategories: {
    reconnaissance: 'Reconocimiento',
    web: 'Escáner Web',
    cms: 'Escáneres CMS',
    vulnerabilities: 'Escáneres de Vulnerabilidades',
    bruteforce: 'Fuerza Bruta',
    ad: 'Active Directory',
    ldap: 'LDAP / LDAPS',
    services: 'Enumeración de Servicios',
    osint: 'Inteligencia de fuentes abiertas (OSINT)',
    suites: 'Suites de Seguridad',
    ssl: 'SSL/TLS',
    ot: 'OT/ICS/SCADA',
    iot: 'Dispositivos IoT',
    pivoting: 'Pivoting y Tunelización',
    privesc: 'Escalada de Privilegios',
    evasion: 'Evasión y Bypass',
    supply_chain: 'Seguridad de la Cadena de Suministro',
    network_attack: 'Ataques de Red',
    firewall: 'Box / Cortafuegos / Router',
    vpn: 'Seguridad VPN',
    cloud: 'Seguridad Cloud',
    other: 'Otros'
  },

  // OSINT
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Cabeceras de seguridad',
      security_headers: 'Cabeceras de seguridad',
      email_security: 'Seguridad de correo',
      geoip: 'Geolocalización IP',
      reverse_ip: 'IP inversa',
      full: 'Escaneo completo',
      domain: 'Dominio',
      ip: 'Dirección IP',
      url: 'URL',
      network_discovery: 'Descubrimiento de red',
      vulnerability_scan: 'Escaneo de vulnerabilidades',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      expert: 'Escaneo experto',
      api_pentest: 'Pentest API',
      iot_scan: 'Escaneo IoT',
      ot_scan: 'Escaneo OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Escaneo Active Directory',
      ad_recon: 'Reconocimiento AD',
      ad_full: 'Escaneo AD completo',
      ldap_scan: 'Escaneo LDAP',
      kerberos_scan: 'Escaneo Kerberos',
      web_scan: 'Escaneo Web',
      web: 'Escaneo Web',
      quick: 'Rápido',
      quick_scan: 'Escaneo rápido',
      discovery: 'Descubrimiento',
      enumeration: 'Enumeración',
      vulnerability: 'Vulnerabilidades',
      exploitation: 'Explotación',
      passive: 'Pasivo',
      aggressive: 'Agresivo',
      credentials: 'Credenciales',
      recon: 'Reconocimiento',
      exploit: 'Explotación',
      bypass: 'Bypass',
      nmap: 'Escaneo Nmap',
      nikto: 'Escaneo Nikto',
      internal: 'Escaneo interno',
      external: 'Escaneo externo',
      network: 'Escaneo de red',
      owasp: 'Escaneo OWASP',
      owasp_scan: 'Escaneo OWASP',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'Escaneo ZAP',
      zap_scan: 'Escaneo ZAP',
      owasp_zap: 'Escaneo OWASP ZAP',
      sqlmap: 'Escaneo SQLMap',
      openvas: 'Escaneo OpenVAS',
      nuclei: 'Escaneo Nuclei',
      metasploit: 'Escaneo Metasploit',
      hydra: 'Test Hydra',
      wpscan: 'Escaneo WordPress',
      gobuster: 'Escaneo Gobuster',
      pentest: 'Pentest',
      stealth: 'Escaneo sigiloso',
      full_scan: 'Escaneo completo',
      standard: 'Estándar'
    }
  },

  // Agents
  agents: {
    title: 'Agentes',
    subtitle: 'Agentes de escaneo desplegados en redes internas',
    loading: 'Cargando agentes...',
    register: 'Registrar',
    registerAgent: 'Registrar un agente',
    downloadInstaller: 'Descargar el instalador',
    searchPlaceholder: 'Buscar un agente...',
    noAgentsFound: 'No se encontraron agentes',
    noAgentsRegistered: 'No hay agentes registrados',
    noAgentsFoundHint: 'Modifique su búsqueda o registre un nuevo agente',
    noAgentsRegisteredHint: 'Despliegue un agente en una red cliente para escanear objetivos internos sin VPN',
    loadError: 'Error al cargar los agentes',
    deleteConfirm: '¿Eliminar el agente "{name}"?',
    colAgent: 'Agente',
    colStatus: 'Estado',
    colHostname: 'Hostname',
    colInternalIp: 'IP Interna',
    colLastSeen: 'Última conexión',
    colMetrics: 'Métricas',
    colActions: 'Acciones',
    never: 'Nunca',
    details: 'Detalles',
    delete: 'Eliminar',
    statTotal: 'Total',
    statOnline: 'En línea',
    statOffline: 'Sin conexión',
    statBusy: 'Ocupados',
    loadingAgent: 'Cargando agente...',
    agentNotFound: 'Agente no encontrado',
    backToAgents: 'Volver a los agentes',
    pingAgent: 'Ping',
    pinging: 'Ping...',
    systemCard: 'Sistema',
    networkCard: 'Red',
    registeredCard: 'Registrado',
    tunnelActive: 'Túnel activo',
    polling: 'Polling',
    avg24h: 'prom. 24h',
    recentTasks: 'Tareas recientes',
    noTasksExecuted: 'Ninguna tarea ejecutada'
  },

  // Equipment types
  equipmentTypes: {
    deleteConfirm: '¿Está seguro de que desea eliminar este equipo?',
    launchAttack: 'Lanzar ataque',
    validateDetection: 'Validar detección',
    deleteEquipment: 'Eliminar',
    deleted: 'Equipo eliminado',
    validationError: 'Error durante la validación',
    deleteError: 'Error durante la eliminación',
    categories: {
      server: 'Servidor',
      workstation: 'Estación de trabajo',
      network: 'Red',
      security: 'Seguridad',
      iot: 'IoT',
      ot_ics: 'OT/ICS',
      mobile: 'Móvil',
      cloud: 'Cloud',
      container: 'Contenedor',
      database: 'Base de datos',
      web_application: 'Aplicación Web',
      printer: 'Impresora',
      storage: 'Almacenamiento',
      voip: 'VoIP',
      other: 'Otro'
    }
  },

  // Sessions extra
  sessionsExtra: {
    sessionNotFound: 'Sesión no encontrada',
    privescConfirm: '¿Lanzar un intento de escalada de privilegios?',
    validateForReport: 'Validar para informe',
    chainNames: {
      full_recon: 'Reconocimiento Completo',
      cred_harvest: 'Recolección de Credenciales',
      pivot_recon: 'Descubrimiento de Pivot',
      safe_migrate: 'Migración Segura'
    },
    aptModules: 'Módulos APT (Amenaza Persistente Avanzada)',
    modulesAvailable: 'módulos disponibles'
  },

  // NetworkMap extra
  networkMap: {
    launchOwaspAnalysis: 'Servicios web - Lanzar análisis OWASP',
    launchSimulation: 'Lanzar Simulación'
  },

  // ScanDetails extra
  scanDetails: {
    viewScanConfig: 'Ver configuración del escaneo',
    downloadPdfReport: 'Descargar informe PDF',
    pdfReport: 'Informe PDF',
    relaunch: 'Relanzar',
    relaunchScan: 'Relanzar este escaneo con los mismos parámetros',
    schedule: 'Programar',
    scheduleScan: 'Programar este escaneo',
    refresh: 'Actualizar',
    vpnConnectionRequired: 'Conexión VPN requerida',
    vpnConnectionRequired2: 'Este escaneo requiere una conexión VPN para acceder a la red interna',
    vpnConnectInstructions: 'Conéctese a la VPN configurada para este espacio de trabajo y luego relance el escaneo.',
    configureVpn: 'Configurar VPN',
    viewWorkspaces: 'Ver espacios de trabajo',
    vpnConnection: 'Conexión VPN',
    scanServer: 'Servidor de escaneo',
    vpnActive: 'VPN Activo',
    directConnection: 'Conexión directa',
    vpnServer: 'Servidor VPN',
    hostsDiscovered: 'Hosts descubiertos',
    hostsDiscoveredDesc: 'Número total de máquinas descubiertas y accesibles en el perímetro escaneado.',
    totalVulnerabilities: 'Total de vulnerabilidades',
    totalVulnerabilitiesDesc: 'Número total de fallos de seguridad (CVE) identificados en todos los hosts.',
    criticalVulnerabilities: 'Vulnerabilidades críticas',
    criticalVulnerabilitiesDesc: 'CVSS 9.0-10.0: Fallos que permiten comprometer completamente el sistema.',
    immediateActionRequired: 'Acción inmediata requerida.',
    scanConfiguration: 'Configuración del escaneo',
    target: 'Objetivo',
    scanType: 'Tipo de escaneo',
    createdAt: 'Creado el',
    intensity: 'Intensidad',
    queueHowItWorks: '¿Cómo funciona la cola?',
    queueOrdered: 'Los escaneos se procesan en orden de llegada con prioridad según su plan',
    queueAutoUpdate: 'Esta página se actualiza automáticamente',
    queueAutoStart: 'El escaneo comenzará automáticamente cuando haya recursos disponibles',
    accelerateScans: 'Acelere sus escaneos',
    accelerateDesc: 'Para reducir los tiempos de espera y obtener escaneos prioritarios:',
    proPlanOption: 'Plan Pro o Enterprise',
    proPlanDesc: 'Disfrute de mayor prioridad en la cola y tiempos de espera reducidos',
    dedicatedServer: 'Servidor dedicado',
    dedicatedServerDesc: 'Escaneos instantáneos sin cola - sus propios recursos dedicados',
    viewPlans: 'Ver planes',
    noVulnDetected: 'No se detectaron vulnerabilidades',
    showTop5: 'Mostrar los 5 más graves',
    showAll: 'Mostrar todo',
    viewAll: 'Ver todo',
    viewDetails: 'Ver detalles',
    showingTop5: 'Mostrando las 5 vulnerabilidades {sortType} de {total} en total',
    bySeverity: 'más graves',
    byDate: 'más recientes',
    capturedOn: 'Capturado el',
    imageLoadError: 'Error al cargar la imagen',
    autoGenerateReport: 'Generar informe automáticamente',
    selectReportFormats: 'Seleccione el/los formato(s) de informe a generar',
    reportFormats: 'Formatos de informe',
    reduceList: '← Reducir lista',
    showMoreHosts: 'Ver los {count} hosts restantes →',
    stopScanConfirm: '¿Está seguro de que desea detener este escaneo?',
    deleteScanConfirm: '¿Está seguro de que desea eliminar este escaneo?',
    retryScanConfirm: '¿Relanzar este escaneo con los mismos parámetros?',
    stopScanFailed: 'Error al detener el escaneo',
    deleteScanFailed: 'Error al eliminar el escaneo',
    cleanupFailed: 'Error de limpieza',
    immediatePatching: 'Parcheo inmediato',
    immediatePatchingDesc: 'Aplicar parches de seguridad para las vulnerabilidades críticas y altas identificadas.',
    reduceAttackSurface: 'Reducción de la superficie de ataque',
    reduceAttackSurfaceDesc: 'Cerrar puertos no esenciales y limitar la exposición de servicios.',
    updateComponents: 'Actualización de componentes',
    updateComponentsDesc: 'Actualizar el software vulnerable a sus últimas versiones seguras.',
    continuousMonitoring: 'Monitorización continua',
    continuousMonitoringDesc: 'Implementar monitorización de logs y alertas para detectar actividad sospechosa.',
    noCriticalVulnsDetected: 'No se detectaron vulnerabilidades críticas',
    majorityLowSeverity: 'Mayoría de vulnerabilidades de baja gravedad',
    fullCoverageMultipleTools: 'Cobertura completa con múltiples herramientas de análisis',
    automatedScanFastDetection: 'Escaneo automatizado para detección rápida',
    aiAssistedReport: 'Informe generado con asistencia IA para análisis profundo',
    implementSecurityRecommendations: 'Implementar recomendaciones de seguridad',
    strengthenNetworkSegmentation: 'Reforzar la segmentación de red',
    vulnManagementProgram: 'Programa de gestión de vulnerabilidades',
    regularSecurityAudits: 'Auditorías de seguridad regulares',
    securityAwarenessTraining: 'Formación en concienciación de seguridad',
    hostsLabel: 'Hosts',
    vulnerabilitiesLabel: 'Vulnerabilidades',
    criticalLabel: 'Críticos',
    highLabel: 'Altos',
    mediumLabel: 'Medios',
    lowLabel: 'Bajos',
    highVulnsDesc: 'CVSS 7.0-8.9: Fallos que pueden llevar a acceso no autorizado o fuga de datos.',
    mediumVulnsDesc: 'CVSS 4.0-6.9: Fallos que requieren condiciones específicas para ser explotados.',
    lowVulnsDesc: 'CVSS 0.1-3.9: Fallos de impacto limitado, a tratar en mantenimientos planificados.'
  },

  // Subdomains
  subdomains: {
    title: 'Subdomain Discovery',
    description: 'Descubra subdominios y lance ataques automatizados',
    searchTitle: 'Búsqueda de Subdominios',
    domainPlaceholder: 'ejemplo.com',
    scanning: 'Escaneando...',
    quickScan: 'Escaneo rápido',
    fullScan: 'Escaneo completo',
    toolsLabel: 'Herramientas del escaneo completo',
    sessionExpired: 'Sesión expirada. Por favor, inicie sesión de nuevo.',
    discoveryError: 'Error durante el descubrimiento de subdominios',
    networkError: 'Error de red. Verifique su conexión.',
    enterDomain: 'Por favor, introduzca un dominio',
    selectAtLeastOne: 'Seleccione al menos un subdominio',
    subdomainsDiscovered: '{count} subdominios descubiertos',
    savedToWorkspace: ' — guardado en el espacio de trabajo',
    totalDiscovered: 'Total descubiertos',
    active: 'Activos (resolubles)',
    selected: 'Seleccionados',
    duration: 'Duración',
    selectAllActive: 'Seleccionar todos los activos',
    deselectAll: 'Deseleccionar todo',
    scanSelected: 'Escanear selección ({count})',
    attacking: 'Atacando...',
    scansLaunched: '{count} escaneo(s) lanzado(s) en los subdominios seleccionados',
    discoveredSubdomains: 'Subdominios descubiertos',
    noAliveSubdomains: 'No se encontraron subdominios activos',
    noAliveSubdomainsDesc: 'Este dominio puede no tener subdominios indexados públicamente',
    resultsByTool: 'Resultados por herramienta',
    emptyStateTitle: 'Subdomain Discovery',
    emptyStateDesc: 'Introduzca un dominio arriba para descubrir todos sus subdominios.',
    quickScanHint: 'para una búsqueda rápida con Subfinder,',
    fullScanHint: 'para una búsqueda profunda.',
    configurableTools: 'Herramientas configurables: Subfinder, Amass, DNSRecon, Resolución IP',
    dataFromWorkspace: 'Datos cargados desde el espacio de trabajo',
    rerunToRefresh: '— Relance un escaneo para actualizar',
    enrichedResultsSaved: 'Resultados enriquecidos guardados en el espacio de trabajo',
    quickDiscoveryError: 'Error durante el descubrimiento rápido'
  },

  // AI Agent
  aiAgent: {
    configTitle: 'Configuración del Agente',
    configSubtitle: 'Ajuste los umbrales y comportamientos del agente IA',
    reset: 'Restablecer',
    save: 'Guardar',
    generalSettings: 'Configuración general',
    agentActive: 'Agente activo',
    automaticMonitoring: 'Monitorización automática',
    autoRecovery: 'Auto-recuperación',
    automaticRecovery: 'Recuperación automática',
    dailyReport: 'Informe diario',
    summaryEmail: 'Correo de resumen',
    alertThresholds: 'Umbrales de alerta',
    alert: 'Alerta',
    critical: 'Crítico',
    memory: 'Memoria',
    disk: 'Disco',
    intervals: 'Intervalos',
    monitoringSeconds: 'Monitorización (segundos)',
    aiAnalysisSeconds: 'Análisis IA (segundos)',
    healthCheckSeconds: 'Health Check (segundos)',
    scanSettings: 'Configuración de escaneo',
    scanTimeoutMin: 'Timeout escaneo (minutos)',
    maxConcurrentScans: 'Escaneos simultáneos máx.',
    errorRateThreshold: 'Tasa de error umbral (/h)',
    alerts: 'Alertas',
    alertEmail: 'Correo de alerta',
    maxAlertsHour: 'Alertas máx./hora',
    deduplication: 'Deduplicación (minutos)',
    aiModels: 'Modelos IA',
    primaryModel: 'Modelo principal',
    strategicModel: 'Modelo estratégico',
    technicalModel: 'Modelo técnico',
    codeModel: 'Modelo de código',
    dailyReportSettings: 'Informe diario',
    sendTime: 'Hora de envío',
    utcNote: '0-23 (hora UTC)',
    recipients: 'Destinatarios (uno por línea)',
    conversationHistory: 'Historial de conversaciones IA',
    noConversations: 'Sin conversaciones',
    selectConversation: 'Seleccione una conversación',
    configSaved: 'Configuración guardada',
    configSaveError: 'Error al guardar la configuración',
    configReset: 'Configuración restablecida',
    configResetError: 'Error al restablecer la configuración',
    configResetConfirm: '¿Restablecer la configuración predeterminada?',
    deleteConversationConfirm: '¿Eliminar esta conversación?',
    conversationDeleted: 'Conversación eliminada',
    conversationDeleteError: 'Error al eliminar',
    loadMessagesError: 'Error al cargar los mensajes',
    untitledConversation: 'Conversación sin título',
    modelsTitle: 'Modelos IA (Ollama)',
    modelsSubtitle: 'Estado de los modelos LLM utilizados por el agente',
    ollamaOnline: 'En línea',
    ollamaStopped: 'Detenido',
    ollamaError: 'Error',
    vramAvailable: 'Memoria disponible para los modelos',
    defaultModel: 'Modelo predeterminado',
    availableModels: 'Modelos disponibles',
    loaded: 'Cargado',
    available: 'Disponible',
    notAvailable: 'No disponible',
    noModelsDetected: 'No se detectaron modelos',
    usageStats: 'Estadísticas de uso ({period})',
    totalRequests: 'Total de solicitudes',
    tokensUsed: 'Tokens utilizados',
    requestsByModel: 'Solicitudes por modelo',
    avgLatency: 'Latencia media (ms)',
    testModel: 'Probar',
    modelError: 'Error: {error}',
    testError: 'Error durante la prueba',
    loadModelsError: 'Error al cargar los modelos',
    actionsTitle: 'Historial de Acciones',
    actionsSubtitle: 'Acciones ejecutadas por el agente IA',
    totalActions: 'Total de acciones',
    successful: 'Exitosas',
    failed: 'Fallidas',
    successRate: 'Tasa de éxito',
    actionsByType: 'Acciones por tipo',
    noActionsRecorded: 'No hay acciones registradas',
    filterType: 'Tipo',
    filterCategory: 'Categoría',
    filterResult: 'Resultado',
    all: 'Todos',
    allCategories: 'Todas',
    succeeded: 'Exitoso',
    loadActionsError: 'Error al cargar las acciones',
    metricsTitle: 'Métricas del sistema',
    noData: 'Sin datos',
    loadMetricsError: 'Error al cargar las métricas',
    incidentsTitle: 'Incidentes',
    incidentsSubtitle: 'Incidentes detectados por el agente IA',
    acknowledge: 'Acusar recibo',
    resolve: 'Resolver',
    retryRecovery: 'Relanzar la recuperación',
    incidentAcknowledged: 'Incidente acusado de recibo',
    incidentResolved: 'Incidente resuelto',
    recoveryRelaunched: 'Recuperación relanzada',
    loadIncidentsError: 'Error al cargar los incidentes',
    noIncidents: 'Sin incidentes',
    filterSeverity: 'Gravedad',
    filterStatus: 'Estado',
    allSeverities: 'Todas',
    allStatuses: 'Todos'
  },

  // Orchestrator
  orchestrator: {
    title: 'Orquestador IA',
    subtitle: 'Motor inteligente de explotación y análisis autónomo',
    active: 'ACTIVO',
    inactive: 'INACTIVO',
    disable: 'Desactivar',
    enable: 'Activar (Modo Seguro)',
    enableSafe: 'Activar',
    retry: 'Reintentar',
    connectionError: 'Error de conexión al orquestador',
    serviceUnavailable: 'Servicio temporalmente no disponible. Por favor, inténtelo de nuevo.',
    stateChangeError: 'Error al cambiar el estado del orquestador',
    activeScans: 'Escaneos activos',
    aiDecisions: 'Decisiones IA',
    aiModels: 'Modelos IA',
    minConfidence: 'Confianza mín.',
    loadedModels: 'Modelos IA cargados',
    loadingModels: 'Cargando modelos Ollama...',
    exploitationMode: 'Modo de explotación',
    confidenceThreshold: 'Umbral de confianza',
    minConfidenceNote: 'Nivel mínimo de confianza para acciones automáticas',
    safeModeNote: 'El modo Seguro evita exploits destructivos',
    recentDecisions: 'Decisiones IA recientes',
    noAiActivity: 'Sin actividad IA',
    decisionsAppearHere: 'Los análisis y decisiones IA aparecerán aquí',
    configuration: 'Configuración'
  },

  // License
  license: {
    expiredBadge: 'LICENCIA EXPIRADA',
    revokedBadge: 'LICENCIA REVOCADA',
    cancelledBadge: 'LICENCIA CANCELADA',
    noLicenseBadge: 'SIN LICENCIA',
    expiredTitle: 'Su licencia ha expirado',
    expiredSubtitle: 'El acceso a la plataforma está suspendido pendiente de renovación.',
    revokedTitle: 'Su licencia ha sido revocada',
    revokedSubtitle: 'El acceso a la plataforma ha sido suspendido por SYLink Security.',
    cancelledTitle: 'Su licencia ha sido cancelada',
    cancelledSubtitle: 'Su suscripción ha sido cancelada. Sus datos se conservan durante 30 días.',
    noLicenseTitle: 'Sin licencia activa',
    noLicenseSubtitle: 'Active una licencia para acceder a la plataforma SYLink Pentest.',
    renewAction: 'Renovar mi licencia',
    accessSettings: 'Acceder a la configuración',
    contactSyLink: 'Contactar SYLink',
    subscribeAction: 'Suscribirse a un nuevo plan',
    exportData: 'Exportar mis datos',
    activateLicense: 'Activar mi licencia',
    licenseInfo: 'Información de licencia',
    reference: 'Referencia',
    tier: 'Nivel',
    expiredOn: 'Expirado el',
    holder: 'Titular',
    expiry: 'Expiración',
    plan: 'Plan',
    loggedAs: 'Conectado como',
    adminBypass: 'Administrador - Redirigiendo al panel...',
    contactSupport: 'Contactar soporte',
    warningExpired: 'Sus datos están preservados. Renueve su licencia para restaurar el acceso completo.',
    warningExpiredEmail: 'Se ha enviado un correo de recordatorio a',
    warningRevoked: 'El acceso ha sido revocado por decisión administrativa.',
    warningCancelled: 'Su suscripción ha sido cancelada. Tiene 30 días para exportar sus datos.',
    warningNoLicense: 'Acceda a la configuración de su cuenta para ingresar su clave de licencia.',
    needHelp: '¿Necesita ayuda?'
  },

  // Accept Invitation
  acceptInvitation: {
    verifying: 'Verificando la invitación...',
    alreadyActivatedTitle: 'Cuenta ya activada',
    alreadyActivatedDesc: 'Su cuenta ha sido activada con éxito. Ya puede iniciar sesión.',
    login: 'Iniciar sesión',
    invitationExpiredTitle: 'Invitación expirada',
    invitationInvalidTitle: 'Invitación inválida',
    expiredHint: 'Las invitaciones son válidas 7 días. Solicite a su administrador que envíe una nueva.',
    invalidHint: 'Si recibió varios correos de invitación, use el enlace del último.',
    contactSupport: 'Contactar soporte',
    welcomeTitle: '¡Bienvenido al equipo!',
    accountActivated: 'Su cuenta ha sido activada con éxito.',
    redirecting: 'Redirigiendo al panel...',
    joinTeamTitle: 'Invitación para unirse al equipo',
    missingToken: 'Token de invitación faltante',
    acceptError: 'Error al aceptar la invitación',
    genericError: 'Se ha producido un error'
  },

  // Dedicated Server
  dedicatedServer: {
    pageTitle: 'Servidor dedicado - Infraestructura soberana',
    heroTag: 'Solución soberana 100% francesa',
    heroTitle: 'Infraestructura',
    heroTitleHighlight: 'Dedicada',
    heroDesc: 'Una solución de pentest aislada, gestionada y supervisada para su empresa. Alojada en Francia, sin las restricciones de las soluciones extranjeras.',
    statFrench: 'Francesa',
    statQueue: 'Cola de espera',
    statSupervision: 'Supervisión',
    statAvailability: 'Disponibilidad',
    whyDedicated: '¿Por qué elegir la infraestructura dedicada?',
    whyDedicatedDesc: 'Benefíciese de una solución a medida adaptada a sus exigencias de seguridad y rendimiento',
    hostingOptions: 'Opciones de alojamiento',
    hostingOptionsDesc: 'Elija el alojamiento que corresponde a sus necesidades: en nuestro datacenter soberano o directamente en su infraestructura',
    recommended: 'Recomendado',
    aiTitle: 'SYLink IA - Modelos de ciberseguridad especializados',
    aiDesc: 'Despliegue nuestra IA de ciberseguridad especializada directamente en su infraestructura. Análisis local, sin envío de datos al exterior.',
    parameters: 'parámetros',
    poweredBy: 'Impulsado por Ollama',
    localLLM: 'Ejecución local de modelos LLM',
    viewOnOllama: 'Ver en Ollama',
    ctaTitle: '¿Listo para pasar a la infraestructura dedicada?',
    ctaDesc: 'Contacte a nuestro equipo comercial para una evaluación personalizada de sus necesidades y un presupuesto a medida.',
    requestQuote: 'Solicitar presupuesto',
    viewAllPlans: 'Ver todos los planes',
    trustFrenchTech: 'Tecnología francesa',
    trustFrenchTechDesc: 'Desarrollado en Francia, sin dependencia de tecnologías extranjeras',
    trustGDPR: 'Conformidad RGPD',
    trustGDPRDesc: 'Alojamiento soberano conforme a las regulaciones europeas',
    trustProtectedData: 'Datos protegidos',
    trustProtectedDataDesc: 'Sus datos permanecen en Francia, protegidos del Cloud Act y el FISA',
    adv1Title: 'Aislamiento Total',
    adv1Desc: 'Infraestructura dedicada y aislada para máxima seguridad. Sin compartición de recursos con otros clientes.',
    adv2Title: 'Rendimiento Garantizado',
    adv2Desc: 'Recursos de CPU, RAM y almacenamiento dedicados. Escaneos instantáneos sin colas ni limitaciones.',
    adv3Title: 'Soberanía de datos',
    adv3Desc: 'Alojamiento 100% francés, sin restricciones de soluciones extranjeras (Cloud Act, FISA).',
    adv4Title: 'Supervisión 24/7',
    adv4Desc: 'Vigilancia continua, alertas en tiempo real e intervención proactiva de nuestros equipos.',
    adv5Title: 'Soporte Dedicado',
    adv5Desc: 'Equipo técnico dedicado, SLA garantizado y acompañamiento personalizado.',
    adv6Title: 'Disponibilidad 99,9%',
    adv6Desc: 'Infraestructura redundante con alta disponibilidad y plan de recuperación ante desastres.',
    hostingDatacenterTitle: 'France Data Center - Reims',
    hostingDatacenterLoc: 'Reims, Francia',
    hostingOnPremTitle: 'En sus instalaciones',
    hostingOnPremLoc: 'Su infraestructura',
    ai8bDesc: 'Modelo ligero y rápido para análisis estándar',
    ai8bSpecs: 'GPU: 8 GB VRAM mínimo',
    ai8bUseCase: 'Análisis rápidos, informes automatizados',
    ai30bDesc: 'Modelo equilibrado para análisis profundos',
    ai30bSpecs: 'GPU: 24 GB VRAM mínimo',
    ai30bUseCase: 'Análisis detallados, correlaciones avanzadas',
    ai80bDesc: 'Modelo experto para análisis complejos',
    ai80bSpecs: 'GPU: 80 GB VRAM mínimo',
    ai80bUseCase: 'Análisis expertos, investigación de vulnerabilidades'
  },

  // Account Reports Config page
  accountReports: {
    configSaved: 'Configuración guardada',
    configSaveError: 'Error al guardar la configuración',
    clientAdded: 'Cliente añadido',
    clientAddError: 'Error al añadir',
    clientDeleted: 'Cliente eliminado',
    clientDeleteError: 'Error al eliminar',
    loadError: 'Error al cargar',
    deleteClientConfirm: '¿Eliminar este cliente?',
    unsavedChanges: 'Tiene cambios sin guardar',
    save: 'Guardar',
    saving: 'Guardando...',
    clientsTitle: 'Clientes',
    addClient: 'Añadir',
    clientName: 'Nombre del cliente *',
    sirenOptional: 'SIREN (opcional)',
    noClientsConfigured: 'Ningún cliente configurado',
    reportTypesTitle: 'Tipos de Informes',
    reportTypesDesc: 'Personalice los tipos de informes disponibles para su organización',
    customName: 'Nombre personalizado',
    customDescription: 'Descripción personalizada',
    infoNote: 'Estos parámetros son específicos de su organización. Los cambios solo afectan a sus informes.'
  }
};
